import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { NgxSpinnerService } from "ngx-spinner";
import swal from 'sweetalert2';
import { ProfileService } from '../service/profile.service'
import { Router } from '@angular/router';
import { MainService } from '../service/main.service';
import { TaskService } from '../service/task.service';
import { UserAddService } from '../service/user-add.service';
import { EstablishmentService } from '../../hrms/service/establishment.service';
// import { EbillPrintService } from '../service/ebill-print.service';
import { PrintSalBillService } from '../service/print-sal-bill.service';
import { AllEmpService } from '../../hrms/service/all-emp.service';
import { ApprovalUserService } from '../service/approval-user.service';
import { DomSanitizer } from '@angular/platform-browser';
// import { TenderService } from './../../emb/service/tender.service';
// import { EbillService } from './../../emb/service/ebill.service';
// import { MainService as EmbMainService } from './../../emb/service/main.service'
// import { MainService as operationMainService } from './../../operation/service/main.service'
// import { MasterDataService } from './../../emb/service/master-data.service'
// import {EbillMainService} from './../../emb/service/main.service';
// import { EmbPrintService } from './../../emb/common _services/emb-print.service';
// import { CommonDataService as EmbCommonDataService } from './../../emb/common _services/common-data.service';
// import { LitigationService } from '../../icms/service/litigation.service';
// import { ReportService } from '../../icms/service/report.service';
import Swal from 'sweetalert2';
import { AcrService } from '../../hrms/service/acr.service';
import { BpService } from '../../accounts/service/bp.service';
import { BillService } from '../../accounts/service/bill.service';
import { SettingService } from '../../accounts/service/setting.service';
import { LedgerService } from '../../accounts/service/ledger.service';
import { RuleService } from '../../accounts/service/rule.service';
import { MatSnackBar } from '@angular/material/snack-bar';
// import { BillService as vbillservice } from '../../operation/service/bill.service'
import { PayrollService } from '../../../app/hrms/service/payroll.service';
import { ProcessDocumentService } from '../../accounts/service/process-document.service';
import { ProcessDocumentPrintService } from '../../accounts/service/process-document-print.service';
// import { BillPrintService } from '../../operation/common _services/bill-print.service';
import { EventGroupService } from '../../accounts/service/event-group.service';
import { EditorService } from '../../md/service/editor.service';
import { MainService as portal_Mainservice } from '../../portal/service/main.service'
// import { WorkOrderService } from '../../operation/service/work-order.service'
import { AuthenticationService } from '../../authentication.service';
import { session } from '../../../environments/environment.session'
import { ReimbursementService } from 'src/app/accounts/service/reimbursement.service';
// import { SubsidyService } from '../../operation/service/subsidy.service';

import * as pdfMake from "pdfmake/build/pdfmake";
import * as pdfFonts from "pdfmake/build/vfs_fonts"
import { WorkService } from '../../accounts/service/work.service';
import { Utf8EncodingService } from 'src/app/md/service/utf8-encoding.service';
// import { FileService } from '../../computer/service/file.service';
// import { FileService as StmFileService } from '../../stm/service/file.service';



(pdfMake as any).vfs = (pdfFonts as any).default.vfs;

declare var $: any
@Component({
  selector: 'app-task',
  templateUrl: './task.component.html',
  styleUrls: ['./task.component.css']
})
export class TaskComponent implements OnInit {
  systemDate: any;

  constructor(
    //     private wos: WorkOrderService, private embPrintService: EmbPrintService,
    //     private ebillService: EbillService, private tenderService: TenderService,
    //     private embMainService: EmbMainService, private masterDataService: MasterDataService,
    //     private embCommonDataService: EmbCommonDataService,private operationMainService: operationMainService,
    //  private vbillservice: vbillservice, private billPrintService: BillPrintService, 
    //  private subsidyService: SubsidyService, private stmFileService: StmFileService,
    // private ComputerFileService: FileService, private ebillPrintService: EbillPrintService, 

    public portal_main: portal_Mainservice, private payableService1: PayrollService,
    private printSalBillService: PrintSalBillService,
   public ApprovalUserService: ApprovalUserService,
    private allEmpService: AllEmpService, private sanitizer: DomSanitizer, private payableService: EstablishmentService,
    private userAdd: UserAddService, private spinner: NgxSpinnerService, private router: Router, private profileService: ProfileService,
    public mainService: MainService, private taskService: TaskService,
    private BPS: BpService, private snackBar: MatSnackBar,
    // private liti: LitigationService, private ICMS_ReportService: ReportService,
    private acrService: AcrService, private billService: BillService,
    private settingService: SettingService, private ledgerService: LedgerService, private ruleService: RuleService,
    private processDocumentService: ProcessDocumentService, private processDocumentPrintService: ProcessDocumentPrintService,
    private eventGroupService: EventGroupService,
    private editorService: EditorService, public auth: AuthenticationService, private _router: Router,
    private reimbursementService: ReimbursementService,
    private workS: WorkService,
    private utf8EncodingService: Utf8EncodingService


  ) { }


  erpUser: any = {};
  b_acct_id: any;
  allEmplyees: any = []
  allCurrentArrangements: any = []
  currentBillObj: any = { header: {}, allEmployees: [], data: {}, sums: {} };
  monthObj: any = { '1': 'January', '2': 'February', '3': 'March', '4': 'April', '5': 'May', '6': 'June', '7': 'July', '8': 'August', '9': 'September', '10': 'October', '11': 'November', '12': 'December' }
  monthEnd: any = { '1': 31, '2': 28, '3': 31, '4': 30, '5': 31, '6': 30, '7': 31, '8': 31, '9': 30, '10': 31, '11': 30, '12': 31 }
  salaryObj: any = { accrual_date: '', b_acct_id: '', fin_year: '', month: '', section_code: '', post_info: {}, emp_info: {}, employement_info: {}, bank_info: {}, att_info: {}, fixed_pay_info: {}, variable_pay_info: {}, total_pay: {} }
  allBillData: any = []
  allApprovalStatus: any = [];
  allApproval: any = []
  approvalObj: any = {};
  allTask: any = {};
  allTaskArr: any = [];
  taskStatus: any = [];
  mxApprovl: any = {};
  payArr: any = []
  dedArr: any = [];
  gross: any = 0;
  net: any = 0;
  netded: any = 0;
  codeVal: any = { 'SALBILL': 'Salary Bill' }
  bank_payment_button: boolean = false
  is_bp_doc: boolean = false;
  statusArr: any = []
  lang_list: any = ['English', 'Hindi']
  font_list: any = ['Mangal', 'Kruti Dev']
  remark_view: any = false
  task_list: any = true
  approval_flag: any = false
  reject_flag: any = false
  multiple_view: any = false
  button_flag: any = false
  // m_avinash (doing it for Acr)
  // before approve acr validation check

  // panelOpenState = true;
  // expandedElement: any | null;
  acrValid: boolean = false
  expandedState: any;
  @ViewChild('textContent', { static: true }) textContent!: ElementRef<HTMLButtonElement>;
  @ViewChild('textContent2', { static: true }) textContent2!: ElementRef<HTMLButtonElement>;

  async ngOnInit() {
    var resp = await this.billService.getSystemDate();
    this.systemDate = resp.data;
    if (history.state['key1'] != undefined) {
      this.acrValid = true;
      swal.fire('Info', ` You Are Hear For Approve ACR Document No ${history.state['key1']}`)
    }
    else {
      this.acrValid = false;
    }
    this.erpUser = this.utf8EncodingService.decodeFromUtf8((session.erpUser));
    this.b_acct_id = this.erpUser.b_acct_id;
    this.approvalObj = this.taskService.approvalObj;
    await this.getAllTaskOfUser();
    // await this.getAllHeadRecord();
    // await this.getAllWorkInfo();
    // await this.getparty();
    await this.getAllParties();
    await this.getActiveFinYear();
    await this.getallChartOfAccount();
  }
  showOtpBtn: any = false
  isDirector: any = false;
  check_all_flag: boolean = false;


  mobile_number: any
  session_id: any
  typeOtp: any = false
  otp_no: any
  resendOTPMessage: any
  async directorVerify() {
    this.mobile_number = this.erpUser.contact_phone
    var resp = await this.auth.sendMsg(this.mobile_number);
    if (resp['Status'] == 'Success') {
      this.session_id = resp['Details']
      this.typeOtp = true
      this.showOtpBtn = false
      this.resendOTP();
    }

  }


  async VerifyOTP() {

    let resp = await this.auth.verifyMsg(this.otp_no, this.session_id)
    if (resp) {
      this.typeOtp = false
      this.isDirector = true
      this.showOtpBtn = false
    } else {
      swal.fire("Error", "OTP DOES NOT MATCHED !!!");
    }
    this.otp_no = null
  }

  time_in_second: any = 30 //in second
  resendOTPbutton: boolean = false;

  async resendOTP() {
    await this.startTimer(this.time_in_second)
    this.resendOTPbutton = true;
    setTimeout(() => {
      this.resendOTPbutton = false;
    }, 1000 * this.time_in_second);
  }

  async startTimer(duration: any) {
    let time: String;
    const timeInterval = setInterval(() => {
      time = this.transform(--duration)
      this.resendOTPMessage = `Resend OTP in  ${time} second `;
      if (time === '0:0') {
        this.resendOTPMessage = ""
        clearInterval(timeInterval);
      }
    }, 1000);
    this.showOtpBtn = false;
  }


  transform(value: number): string {
    const minutes: number = Math.floor(value / 60);
    return minutes + ':' + (value - minutes * 60);
  }

  backToList() {
    this.multiple_view = false
    this.remark_view = false
    this.approval_flag = false
    this.button_flag = false
    this.reject_flag = false
    this.task_list = true
    this.hr_note_sheet = null
  }

  checkAll() {
    if (this.check_all_flag) {
      this.check_all_flag = false
    } else {
      this.check_all_flag = true
    }
    this.allTaskArr.map((x: any) => {
      if (x['doc_type'] === "BP") {
        this.bank_payment_button = true
        x['checked'] = this.check_all_flag
      }
    })
  }
  async download(element: any) {
    // if (element['doc_type'] == 'EBILL') {
    //   await this.ebillPrintService.printEbill(element, this.erpUser)
    // } else if (element['doc_type'] == 'EMB') {
    //   await this.ebillPrintService.printEmb(element, this.erpUser)
    // } else
       if (element['doc_type'] == 'CB_BILL') {
      let obj: any = {}
      obj['b_acct_id'] = this.b_acct_id;
      obj['module_doc_type'] = "CB_BILL"
      obj['id'] = element.doc_local_no
      obj['is_account_module'] = 0
      let resp = await this.eventGroupService.getBillIdAndWorkOrderIdOnEventId(JSON.stringify(obj))

      if (!resp.error) {
        let obj = JSON.parse(JSON.parse(resp['data'][0]['req_data']))
        obj['b_acct_id'] = this.erpUser.b_acct_id;
        let resp0 = await this.billService.printDepBill(obj);
        pdfMake.createPdf(resp0['data']).download("CB_Bill.pdf");

      }
    } else if (element['doc_type'] == 'CB') {
      let obj: any = {}
      obj['b_acct_id'] = this.b_acct_id;
      obj['node_cd'] = element.node_cd
      obj['bill_id'] = element.doc_local_no
      let resp = await this.billService.printDepBill(obj);
      pdfMake.createPdf(resp['data']).download("CB_Bill.pdf");
      // pdfMake.createPdf(resp['data']).open();
    }


    else if (element['doc_type'] == "INSPECTION REPORT") {

      // await this.ICMS_ReportService.printInspectionRep({ b_acct_id: this.erpUser.b_acct_id, user_id: this.erpUser.user_id, complain_id: element.complain_id });
      // await this.ICMS_ReportService.printInspectionRep({ b_acct_id: this.erpUser.b_acct_id, user_id: this.erpUser.user_id, doc_local_no: element.doc_local_no });
    } else if (element['doc_type'] == 'SAL_BILL' || element['doc_type'] == 'AA_BILL') {
      await this.printSalBillService.printSalbill({ bill_id: element['doc_local_no'] }, this.erpUser, 'Task_Sal_Pdf')
    } else if (element['doc_type'] === "SALARY_BILL") {
      let obj: any = {}
      obj['b_acct_id'] = this.b_acct_id;
      obj['module_doc_type'] = "SALARY_BILL"
      obj['id'] = element.doc_local_no
      obj['is_account_module'] = 0
      let resp = await this.eventGroupService.getBillIdAndWorkOrderIdOnEventId(JSON.stringify(obj))

      if (!resp.error) {
        let obj: any = {}
        obj['data'] = resp['bill_id']
        await this.printSalBillService.printSalbill1(JSON.stringify(obj), this.erpUser, 'Task_Sal_Pdf')
      }

    } 
    // else if (element['doc_type'] === 'VENDOR_BILL_OPERATION') {
    //   // await this.billPrintService.print1(element['doc_local_no'])
    //   this.getBillIdUsingEventId({ doc_local_no: element['doc_local_no'], doc_type: element['doc_type'] }).then(async (res) => {
    //     if (!res.error) {
    //       await this.billPrintService.print1(res.doc_local_no, 'OPEN_ON_WINDOW')
    //     }
    //   })

    // } 
    else if (element['doc_type'] === 'ARREAR_BILL') {
      // await this.billPrintService.print1(element['doc_local_no'])
      this.getBillIdUsingEventId({ doc_local_no: element['doc_local_no'], doc_type: element['doc_type'] }).then(async (res) => {
        if (!res.error) {
          await this.printSalBillService.printSalbill(JSON.stringify({ bill_id: res.doc_local_no }), this.erpUser, 'Task_Sal_Pdf')
        }
      })

    } else if (element['doc_type'] === 'DA_ARREAR_BILL') {
      // await this.billPrintService.print1(element['doc_local_no'])
      this.getBillIdUsingEventId({ doc_local_no: element['doc_local_no'], doc_type: element['doc_type'] }).then(async (res) => {
        if (!res.error) {
          let obj: any = {}
          obj['arrear_id'] = res.doc_local_no;
          obj['district'] = JSON.parse(element.node_cd)

          await this.printSalBillService.printdaarreardata(obj, this.erpUser, 'TASK_DA_PRINT')
        } else {
          swal.fire('ERROR', 'Somthing went wrong', 'error')
          return
        }
      })

    } else if (element['doc_type'] === 'DA_ARREAR') {
      // await this.billPrintService.print1(element['doc_local_no'])
      // this.getBillIdUsingEventId({ doc_local_no: element['doc_local_no'], doc_type: element['doc_type'] }).then(async (res) => {
      //   if (!res.error) {
      let obj: any = {}
      obj['arrear_id'] = element['doc_local_no'];
      obj['district'] = JSON.parse(element.node_cd)
      await this.printSalBillService.printdaarreardata(obj, this.erpUser, 'TASK_DA_PRINT')
      // } 
      // })

    } else if (element['doc_type'] === 'ACP_ARREAR_BILL') {
      // await this.billPrintService.print1(element['doc_local_no'])
      this.getBillIdUsingEventId({ doc_local_no: element['doc_local_no'], doc_type: element['doc_type'] }).then(async (res) => {
        if (!res.error) {
          let bill_id = res.doc_local_no;

          await this.printSalBillService.printGratuityDetails(bill_id)
        } else {
          swal.fire('ERROR', 'Somthing went wrong', 'error')
          return
        }
      })

    } else if (element['doc_type'] === 'GRATUITY_BILL') {
      // await this.billPrintService.print1(element['doc_local_no'])
      this.getBillIdUsingEventId({ doc_local_no: element['doc_local_no'], doc_type: element['doc_type'] }).then(async (res) => {
        if (!res.error) {
          let bill_id = res.doc_local_no;
          await this.printSalBillService.printGratuityDetails(bill_id)
        } else {
          swal.fire('ERROR', 'Somthing went wrong', 'error')
          return
        }
      })

    } else if (element['doc_type'] === 'PO_REIMBURSEMENT') {
      this.reimbursementService.isRoutrToTask = true;
      this.reimbursementService.routerData = element;
      this.reimbursementService.routeAction = "VIEW"
      this.reimbursementService.routeOrigin = "task"
      this.router.navigate(['/accounts/setting/reimbursement']);
    } else if (element['doc_type'] === 'PO_REIMBURSEMENT_BILL') {
      const resp = await this.eventGroupService.getBillIdUsingEventId(JSON.stringify({ id: element.doc_local_no, doc_type: element.doc_type, b_acct_id: this.b_acct_id }))
      element['doc_local_no'] = resp['data'][0]['local_doc_no']
      this.reimbursementService.isRoutrToTask = true;
      this.reimbursementService.routerData = element;
      this.reimbursementService.routeAction = "VIEW"
      this.reimbursementService.routeOrigin = "task"
      this.router.navigate(['/accounts/setting/reimbursement']);
    } else if (element['doc_type'] === 'LEAVE_ENCASHMENT_BILL') {
      this.getBillIdUsingEventId({ doc_local_no: element['doc_local_no'], doc_type: element['doc_type'] }).then(async (res) => {
        if (!res.error) {
          let bill_id = res.doc_local_no;
          await this.printSalBillService.printLeaveEncashmentDetails(bill_id)
        } else {
          swal.fire('ERROR', 'Somthing went wrong', 'error')
          return
        }
      })

    } else if (element['doc_type'] === 'LEAVE_ENCASHMENT') {
      await this.printSalBillService.printLeaveEncashmentDetails(element['doc_local_no'])
    } else if (element['doc_type'] === 'GRATUITY') {
      await this.printSalBillService.printGratuityDetails(element['doc_local_no'])
    }
  }
  updateReimbursement(element: any) {
    this.reimbursementService.isRoutrToTask = true;
    this.reimbursementService.routeAction = "UPDATE"
    this.reimbursementService.routerData = element;
    this.reimbursementService.routeOrigin = "task"
    this.router.navigate(['/accounts/setting/reimbursement']);
  }
  async getBillIdUsingEventId(obj2: any) {
    let obj: any = {}
    obj["b_acct_id"] = this.b_acct_id;
    obj["id"] = obj2.doc_local_no;
    obj['doc_type'] = obj2.doc_type

    this.spinner.show();
    var resp = await this.eventGroupService.getBillIdUsingEventId(JSON.stringify(obj));
    if (resp['error'] == false) {
      this.spinner.hide()
      return { doc_local_no: resp['data'][0]['local_doc_no'], error: false }
    } else {
      this.spinner.hide();
      swal.fire("Error", "Error while getting status");
      return { error: true }
    }

  }
  bpDataObj: { [key: string]: { [key: string]: any }[] } = {};
  async allNotesheet() {

    let doc_loca_arr: any = []
    let node__array: any = []

    this.log_message = 'APPROVAL LOG OF - BANK PAYMENT';
    let level = 0;
    let branch = 0
    this.allTaskArr.map((x: any) => {
      if (x['doc_type'] == "BP" && x['checked'] == true) {
        doc_loca_arr.push(x['doc_local_no'])
        node__array.push(x['node_cd'])
        level = x['level']
        branch = x['branch']
      }
    })
    if (doc_loca_arr.length <= 0) {
      Swal.fire('Information', 'Please select any task', 'info');
      return
    }

    let obj: any = {}
    obj["b_acct_id"] = this.b_acct_id;
    obj["doc_local_no"] = doc_loca_arr
    obj["node_cd"] = node__array
    obj['module_cd'] = "ACCOUNT"
    obj['doc_type'] = "BP"
    obj['level'] = level
    obj['branch'] = branch
    this.current_task_data = obj

    this.spinner.show();
    var resp = await this.mainService.getWorkflowlog(JSON.stringify(obj));
    if (resp['error'] == false) {

      this.statusArr = resp['data'];
      this.statusArr.map((x: any) => {

        if (x['remark'] == null || x['remark'] == "" || x['remark'] == undefined) {
          x['remark'] = 'No Remark'
          x['language'] = 'English'
        }

        if (x && 'remark' in x) {
          try {
            const parsedRemark = JSON.parse(x['remark']);
            if (typeof parsedRemark === 'object' && 'body' in parsedRemark) {
              x['remark'] = parsedRemark['body'];
            }
          } catch (e) {


          }
        }

      })
      this.bpDataObj = {}
      this.statusArr.map((x: any) => {
        if (!this.bpDataObj[x['doc_local_no']]) {
          this.bpDataObj[x['doc_local_no']] = []
          this.bpDataObj[x['doc_local_no']].push(x)
        } else {
          this.bpDataObj[x['doc_local_no']].push(x)

        }
      })

      // $('#multiple_view').show()
      this.multiple_view = true
      this.button_flag = true
      this.remark_view = false
      this.approval_flag = false
      this.reject_flag = false
      this.task_list = false
      this.spinner.hide()
    } else {
      this.spinner.hide();
      swal.fire("Error", "Error while getting status");
    }
  }


  // closeMultipleModal() {
  //   $('#multiple_view').hide()
  // }


  // close_btn() {
  //   $('#remark_view').hide()
  // }

  // previous_month_data = []
  // current_month_data = []




  compare_arr: any = []
  comp_code: any
  totaldiff_amt: any = 0
  async checkdiffdata(aa: any) {
    this.compare_arr = []
    this.comp_code = aa.pay_component_code
    this.compare_arr = await this.printSalBillService.showcomapredata(aa, JSON.parse(JSON.stringify(this.total_comprision_data)), this.erpUser)
    this.totaldiff_amt = 0
    this.compare_arr.map((x: any) => {
      this.totaldiff_amt += x["diff_amt"]
    })



    $('#viewdiffrence_data').modal('show');
  }








  diffrence_display_data: any = []
  total_comprision_data: any = []
  log_message: any = ''
  current_task_data: any = {}
  hr_note_sheet: any = ""
  previous_log_status: any = []
  currentObject: any = {}
  notesheet_data: any = {}
  previous_log_message: any = ""
  hr_notesheet_language: any = true
  emp_arr_Sal_Data: any = []
  workDetailsObj: any = {}


  async remarkView(element: any) {

    if (this.erpUser['role_cd'].includes('DIRECTOR') || this.erpUser['role_cd'].includes('Dir') || this.erpUser['role_cd'].includes('DIR_COMP') || this.erpUser['role_cd'].includes('Dir_stm')) {
      this.isDirector = true
      this.showOtpBtn = true
    }
    this.editorService.clearTetx();
    this.forwarded_user_id = null;
    await this.ApprovalUserService.getMostLatestWorkflowlog(this.erpUser, { ...element })
    await this.ApprovalUserService.getWorkflowloguser(this.erpUser, { ...element })
    this.currentObject = JSON.parse(JSON.stringify(element));
    this.notesheet_data = {}
    switch (element.doc_type) {

      case "FILE": {
        this.log_message = 'APPROVAL LOG OF - ACCOUNT FILE';
        this.workDetailsObj = {}
        let resp = await this.processDocumentPrintService.getWorkDetailsByID({ b_acct_id: this.b_acct_id, local_doc_no: element.doc_local_no });
        this.workDetailsObj = resp.data
        break;
      }
      // case "COMPUTER_FILE": {
      //   this.log_message = 'APPROVAL LOG OF - COMPUTER FILE';
      //   this.workDetailsObj = {}
      //   let resp = await this.ComputerFileService.getComputerWorkDetailsByID({ b_acct_id: this.b_acct_id, local_doc_no: element.doc_local_no });
      //   this.workDetailsObj = resp.data
      //   break;
      // }
      // case "STM_FILE": {
      //   this.log_message = 'APPROVAL LOG OF - STORE MANAGEMENT FILE';
      //   this.workDetailsObj = {}
      //   let resp = await this.stmFileService.getSTMWorkDetailsByID({ b_acct_id: this.b_acct_id, local_doc_no: element.doc_local_no });
      //   this.workDetailsObj = resp.data
      //   break;
      // }

      // case "VENDOR_BILL_OPERATION": {
      //   this.log_message = 'CURRENT APPROVAL LOG OF - VENDOR BILL';
      //   this.previous_log_message = "PREVIOUS APPROVAL LOG OF - VENDOR BILL"
      //   this.previous_log_status = []
      //   const data = await this.processDocumentPrintService.getNotesheetData(element)
      //   if (data.error === false) {
      //     this.hindi_text_flag = data.hindi_text_flag;
      //     this.notesheet_data = ""
      //     if (data.error == false && data.data['body']) {
      //       this.notesheet_data = data.data['body']
      //     } else if (data.error == false) {
      //       this.notesheet_data = data.data
      //     }
      //   }
      //   let obj: any = new Object();
      //   obj['event_id'] = element.doc_local_no
      //   obj['b_acct_id'] = this.erpUser.b_acct_id;
      //   obj['ar_actvty_tcd'] = "VENDOR_BILL"
      //   obj['module_cd'] = "OPERATION"
      //   obj['ld_prj_cd'] = element.node_cd
      //   obj['is_account_module'] = 0;
      //   this.previous_log_status = await this.processDocumentPrintService.viewStatus(obj)
      //   // await this.getPreviousWorkflowLog({ ...element, module_cd: "OPERATION", doc_type: "VENDOR_BILL" })
      //   break;
      // }
      case "SUBSIDY_BILL": {
        this.log_message = 'CURRENT APPROVAL LOG OF - SUBSIDY BILL';
        this.previous_log_message = "PREVIOUS APPROVAL LOG OF - SUBSIDY BILL"
        this.previous_log_status = []
        // const data = await this.processDocumentPrintService.getNotesheetData(element)
        // if (data.error === false) {
        //   this.hindi_text_flag = data.hindi_text_flag;
        //   this.notesheet_data = ""
        //   if (data.error == false && data.data['body']) {
        //     this.notesheet_data = data.data['body']
        //   } else if (data.error == false) {
        //     this.notesheet_data = data.data
        //   }
        // }
        let obj: any = new Object();
        obj['event_id'] = element.doc_local_no
        obj['b_acct_id'] = this.erpUser.b_acct_id;
        obj['ar_actvty_tcd'] = "SUBSIDY"
        obj['module_cd'] = "OPERATION"
        obj['ld_prj_cd'] = element.node_cd
        obj['is_account_module'] = 0;
        this.previous_log_status = await this.processDocumentPrintService.viewStatus(obj)
        // await this.getPreviousWorkflowLog({ ...element, module_cd: "OPERATION", doc_type: "VENDOR_BILL" })
        break;
      }
      case "WORK ORDER": this.log_message = 'APPROVAL LOG OF - WORK ORDER'
        break;
      // case "VENDOR_BILL": {
      //   this.log_message = 'APPROVAL LOG OF - VENDOR BILL'
      //   const data1 = await this.processDocumentPrintService.getNotesheetData(element)
      //   if (data1.error === false) {
      //     this.hindi_text_flag = data1.hindi_text_flag;
      //     this.notesheet_data = ""
      //     if (data1.error == false && data1.data['body']) {
      //       this.notesheet_data = data1.data['body']
      //     } else if (data1.error == false) {
      //       this.notesheet_data = data1.data
      //     }
      //   }
      //   break;
      // }

      case "Rate_Discovery": this.log_message = 'APPROVAL LOG OF - RATE DISCOVERY'
        break;

      case "Note Sheet": this.log_message = 'APPROVAL LOG OF - NOTE SHEET'
        break;

      case "SALARY_BILL":
        {
          this.log_message = 'APPROVAL LOG OF - SALARY BILL';
          this.previous_log_message = "PREVIOUS APPROVAL LOG OF - SALARY BILL"
          let obj: any = new Object();
          obj['event_id'] = element.doc_local_no
          obj['b_acct_id'] = this.erpUser.b_acct_id;
          obj['ar_actvty_tcd'] = "SAL_BILL"
          obj['module_cd'] = "HR"
          obj['node_cd'] = element.node_cd
          obj['is_account_module'] = 0;

          this.hr_note_sheet = ""
          this.hr_notesheet_language = true

          const resp = await this.eventGroupService.getHrNotesheet(JSON.stringify({ b_acct_id: this.b_acct_id, local_doc_no: element.doc_local_no, is_account_module: 0 }));
          if (resp['error'] == false) {
            if (resp['data'].length > 0) {

              this.hr_note_sheet = JSON.parse(resp['data'][0]['remark'])['body']
              this.hr_notesheet_language = resp['data'][0]['language'] === "Hindi" ? true : false
              // this.previou

              this.diffrence_display_data = []
              this.total_comprision_data = []
              this.diffrence_display_data = JSON.parse(resp['data'][0]['comparison_Data'])
              this.total_comprision_data = resp['data'][0]

            }
          }

          break;
        }

      case "DA_ARREAR_BILL":
        {
          this.log_message = 'APPROVAL LOG OF - DA ARREAR BILL';
          this.previous_log_message = "PREVIOUS APPROVAL LOG OF - DA ARREAR BILL"
          let obj: any = new Object();
          obj['event_id'] = element.doc_local_no
          obj['b_acct_id'] = this.erpUser.b_acct_id;
          obj['ar_actvty_tcd'] = "DA_ARREAR"
          obj['module_cd'] = "HR"
          obj['node_cd'] = element.node_cd
          obj['is_account_module'] = 0;

          this.hr_note_sheet = ""
          this.hr_notesheet_language = true

          const resp = await this.eventGroupService.getHrNotesheet(JSON.stringify({ b_acct_id: this.b_acct_id, local_doc_no: element.doc_local_no, is_account_module: 0 }));
          if (resp['error'] == false) {
            if (resp['data'].length > 0) {
              this.hr_note_sheet = JSON.parse(resp['data'][0]['remark'])['body']
              this.hr_notesheet_language = resp['data'][0]['language'] === "Hindi" ? true : false

            }
          }

          break;
        }

      case "MEDICAL_BILL": {
        this.log_message = 'CURRENT APPROVAL LOG OF - MEDICAL REIMBURSEMENT BILL';
        this.previous_log_message = "PREVIOUS APPROVAL LOG OF -  MEDICAL REIMBURSEMENT BILL"
        this.previous_log_status = []

        this.hr_note_sheet = ""
        this.hr_notesheet_language = true


        const resp = await this.eventGroupService.getHrNotesheet(JSON.stringify({ b_acct_id: this.b_acct_id, local_doc_no: element.doc_local_no, is_account_module: 0, module_doc_type: 'MEDICAL_BILL' }));
        if (resp['error'] == false) {
          if (resp['data'].length > 0) {
            this.hr_note_sheet = JSON.parse(resp['data'][0]['remark'])['body']
            this.hr_notesheet_language = resp['data'][0]['language'] === "Hindi" ? true : false

          }
        }
        let obj: any = new Object();
        obj['event_id'] = element.doc_local_no
        obj['b_acct_id'] = this.erpUser.b_acct_id;
        obj['ar_actvty_tcd'] = "MED_BILL"
        obj['module_cd'] = "HR"
        obj['ld_prj_cd'] = element.node_cd
        obj['is_account_module'] = 0;
        this.previous_log_status = await this.processDocumentPrintService.viewStatus(obj)
        // await this.getPreviousWorkflowLog({ ...element, module_cd: "OPERATION", doc_type: "VENDOR_BILL" })
        break;
      }

      case "ARREAR_BILL":
        {
          this.log_message = 'APPROVAL LOG OF - ARREAR BILL';
          this.previous_log_message = "PREVIOUS APPROVAL LOG OF - ARREAR BILL"
          let obj: any = new Object();
          obj['event_id'] = element.doc_local_no
          obj['b_acct_id'] = this.erpUser.b_acct_id;
          obj['ar_actvty_tcd'] = "ARREAR_BILL"
          obj['module_cd'] = "HR"
          obj['node_cd'] = element.node_cd
          obj['is_account_module'] = 0;

          this.hr_note_sheet = null
          this.hr_notesheet_language = true

          const resp = await this.eventGroupService.getHrNotesheet(JSON.stringify({ b_acct_id: this.b_acct_id, local_doc_no: element.doc_local_no, is_account_module: 0, module_doc_type: "ARREAR_BILL" }));
          if (resp['error'] == false) {
            if (resp['data'].length > 0) {

              this.hr_note_sheet = JSON.parse(resp['data'][0]['remark'])['body']
              this.hr_notesheet_language = resp['data'][0]['language'] === "Hindi" ? true : false

            }
          }

          break;
        }
      case 'CB_BILL': {

        this.log_message = 'APPROVAL LOG OF - CONTINGENT BILLS';
        this.previous_log_message = "PREVIOUS APPROVAL LOG OF - CONTINGENT BILLS"
        this.previous_log_status = []
        let obj: any = new Object();
        obj['event_id'] = element.doc_local_no
        obj['b_acct_id'] = this.erpUser.b_acct_id;
        obj['ar_actvty_tcd'] = "CB"
        obj['module_cd'] = "ACCOUNT"
        obj['ld_prj_cd'] = element.node_cd
        obj['is_account_module'] = 0;

        this.previous_log_status = await this.processDocumentPrintService.viewStatus(obj)


        break;
      }

      // case "AA_BILL":
      //   {
      //     this.log_message = 'APPROVAL LOG OF - ARREAR BILL'
      //     const resp = await this.eventGroupService.getHrNotesheet(JSON.stringify({ b_acct_id: this.b_acct_id, local_doc_no: element.doc_local_no, is_account_module: 1 }));
      //     if (resp['error'] == false) {
      //       if (resp['data'].length > 0) {
      //         this.hr_note_sheet = resp['data'][0]['remark']
      //         this.hr_notesheet_language = resp['data'][0]['language'] === "Hindi" ? true : false
      //       }
      //     }

      //     break;
      //   }

      // case "BP": {
      //   this.log_message = 'APPROVAL LOG OF - BANK PAYMENT';
      //   this.allTaskArr.map((x:any) => {
      //     if (x['doc_type'] == "BP" && x['checked'] == true) {
      //       doc_loca_arr.push(x['doc_local_no'])
      //     }
      //   })
      // }
      //   break;

      case "ACP_ARREAR_BILL": {
        this.log_message = 'APPROVAL LOG OF - ACP ARREAR BILL';
        this.previous_log_message = " "
        this.hr_note_sheet = ""
        this.hr_notesheet_language = true
        const resp = await this.eventGroupService.getHrNotesheet(JSON.stringify({ b_acct_id: this.b_acct_id, local_doc_no: element.doc_local_no, is_account_module: 0 }));
        if (resp['error'] == false) {
          if (resp['data'].length > 0) {
            this.hr_note_sheet = JSON.parse(resp['data'][0]['remark'])['body']
            this.hr_notesheet_language = resp['data'][0]['language'] === "Hindi" ? true : false
          }
        }
        break;
      }
      case "GRATUITY_BILL": {
        this.log_message = 'APPROVAL LOG OF - GRATUITY BILL';
        this.previous_log_message = " "
        this.hr_note_sheet = ""
        this.hr_notesheet_language = true
        const resp = await this.eventGroupService.getHrNotesheet(JSON.stringify({ b_acct_id: this.b_acct_id, local_doc_no: element.doc_local_no, is_account_module: 0, module_doc_type: element.doc_type }));
        if (resp['error'] == false) {
          if (resp['data'].length > 0) {
            this.hr_note_sheet = JSON.parse(resp['data'][0]['remark'])['body']
            this.hr_notesheet_language = resp['data'][0]['language'] === "Hindi" ? true : false
          }
        }
        break;
      } case "LEAVE_ENCASHMENT_BILL": {
        this.log_message = 'APPROVAL LOG OF - LEAVE ENCASHMENT BILL';
        this.previous_log_message = " "
        this.hr_note_sheet = ""
        this.hr_notesheet_language = true
        const resp = await this.eventGroupService.getHrNotesheet(JSON.stringify({ b_acct_id: this.b_acct_id, local_doc_no: element.doc_local_no, is_account_module: 0, module_doc_type: element.doc_type }));
        if (resp['error'] == false) {
          if (resp['data'].length > 0) {
            this.hr_note_sheet = JSON.parse(resp['data'][0]['remark'])['body']
            this.hr_notesheet_language = resp['data'][0]['language'] === "Hindi" ? true : false
          }
        }
        break;
      }
      case "MANUAL_JOURNAL": this.log_message = 'APPROVAL LOG OF - MANUAL JOURNAL'
        break;
      case "CB": this.log_message = 'APPROVAL LOG OF - CONTINGENT BILLS'
        break;
      case "PO_REIMBURSEMENT": {
        this.log_message = 'APPROVAL LOG OF - PO REIMBURSEMENT'

        const data1 = await this.processDocumentPrintService.getNotesheetOfPoReimbursement({ ...element, is_po_screen: 1 })
        if (data1.error === false) {
          if (data1['data'].length > 1) {
            this.hr_notesheet_language = data1.hindi_text_flag;
            this.hr_note_sheet = ""
            this.hr_note_sheet = data1.data

          }
        }
        break;
      }
      case "PO_REIMBURSEMENT_BILL": {
        this.previous_log_message = "PREVIOUS APPROVAL LOG OF - PO REIMBURSEMENT BILL";
        this.log_message = 'APPROVAL LOG OF - PO REIMBURSEMENT BILL '
        const data1 = await this.processDocumentPrintService.getNotesheetOfPoReimbursement({ ...element, is_po_screen: 0 })
        if (data1.error === false) {
          if (data1['data'].length > 1) {
            this.hr_notesheet_language = data1.hindi_text_flag;
            this.hr_note_sheet = ""
            this.hr_note_sheet = data1.data

            //Previous workflow log 
            this.previous_log_status = []
            let obj: any = new Object();
            obj['event_id'] = element.doc_local_no
            obj['b_acct_id'] = this.erpUser.b_acct_id;
            obj['ar_actvty_tcd'] = "PO_REIMBURSEMENT"
            obj['module_cd'] = "ACCOUNT"
            obj['ld_prj_cd'] = element.node_cd
            obj['is_account_module'] = 0;
            this.previous_log_status = await this.processDocumentPrintService.viewStatus(obj)


          }
        }
        break;
      }




      case "SUSPENSION":
        {
          this.log_message = 'APPROVAL LOG OF - SUSPENSION';
          this.previous_log_message = "PREVIOUS APPROVAL LOG OF - SUSPENSION"
          let obj: any = new Object();
          obj['max_susp_id'] = element.doc_local_no
          obj['b_acct_id'] = this.erpUser.b_acct_id;
          obj['doc_type'] = "SUSPENSION"
          obj['module_cd'] = "HR"
          obj['node_cd'] = element.node_cd


          this.hr_note_sheet = ""
          this.hr_notesheet_language = true

          const resp = await this.eventGroupService.getHrNotesheet(JSON.stringify(obj));
          if (resp['error'] == false) {
            if (resp['data'].length > 0) {

              this.hr_note_sheet = JSON.parse(resp['data'][0]['suspension_note'])['body']
              this.hr_notesheet_language = resp['data'][0]['language'] === "Hindi" ? true : false
              // this.previou
            }
            this.emp_arr_Sal_Data = []
            this.emp_arr_Sal_Data = resp['sal_data']


          }

          break;
        }

      case "REAPOINT":
        {
          this.log_message = 'APPROVAL LOG OF - REAPOINT';
          this.previous_log_message = "PREVIOUS APPROVAL LOG OF - REAPOINT"
          let obj: any = new Object();
          obj['id'] = element.doc_local_no
          obj['b_acct_id'] = this.erpUser.b_acct_id;
          obj['doc_type'] = "REAPOINT"
          obj['module_cd'] = "HR"
          obj['node_cd'] = element.node_cd


          this.hr_note_sheet = ""
          this.hr_notesheet_language = true

          const resp = await this.eventGroupService.getHrNotesheet(JSON.stringify(obj));
          if (resp['error'] == false) {
            if (resp['data'].length > 0) {

              this.hr_note_sheet = JSON.parse(resp['data'][0]['remark'])['body']
              this.hr_notesheet_language = resp['data'][0]['language'] === "Hindi" ? true : false
              // this.previou




            }



          }

          break;
        }


      case "DEATH":
        {
          this.log_message = 'APPROVAL LOG OF - DEATH';
          this.previous_log_message = "PREVIOUS APPROVAL LOG OF - DEATH"
          let obj: any = new Object();
          obj['id'] = element.doc_local_no
          obj['b_acct_id'] = this.erpUser.b_acct_id;
          obj['doc_type'] = "DEATH"
          obj['module_cd'] = "HR"
          obj['node_cd'] = element.node_cd
          obj["life_cycle_status"] = "DEATH"

          this.hr_note_sheet = ""
          this.hr_notesheet_language = true

          const resp = await this.eventGroupService.getHrNotesheet(JSON.stringify(obj));
          if (resp['error'] == false) {
            if (resp['data'].length > 0) {

              this.hr_note_sheet = JSON.parse(resp['data'][0]['remark'])['body']
              this.hr_notesheet_language = resp['data'][0]['language'] === "Hindi" ? true : false
            }
            // this.emp_arr_Sal_Data = []
            // this.emp_arr_Sal_Data = resp['sal_data']


          }

          break;
        }

      case "TRANSFER":
        {
          this.log_message = 'APPROVAL LOG OF - TRANSFER';
          this.previous_log_message = "PREVIOUS APPROVAL LOG OF - TRANSFER"
          let obj: any = new Object();
          obj['id'] = element.doc_local_no
          obj['b_acct_id'] = this.erpUser.b_acct_id;
          obj['doc_type'] = "TRANSFER"
          obj['module_cd'] = "HR"
          obj['node_cd'] = element.node_cd
          obj["life_cycle_status"] = "TRANSFERRED"

          this.hr_note_sheet = ""
          this.hr_notesheet_language = true

          const resp = await this.eventGroupService.getHrNotesheet(JSON.stringify(obj));
          if (resp['error'] == false) {
            if (resp['data'].length > 0) {

              this.hr_note_sheet = JSON.parse(resp['data'][0]['remark'])['body']
              this.hr_notesheet_language = resp['data'][0]['language'] === "Hindi" ? true : false
              // this.previou

            }
            // this.emp_arr_Sal_Data = []
            // this.emp_arr_Sal_Data = resp['sal_data']


          }

          break;
        }

      case "COMPLAINT":
        {
          this.log_message = 'APPROVAL LOG OF - COMPLAINT';
          this.previous_log_message = "PREVIOUS APPROVAL LOG OF - COMPLAINT"
          let obj: any = new Object();
          obj['id'] = element.doc_local_no
          obj['b_acct_id'] = this.erpUser.b_acct_id;
          obj['doc_type'] = "COMPLAINT"
          obj['module_cd'] = "HR"
          obj['node_cd'] = element.node_cd
          obj["life_cycle_status"] = "COMPLAINT"

          this.hr_note_sheet = ""
          this.hr_notesheet_language = true

          const resp = await this.eventGroupService.getHrNotesheet(JSON.stringify(obj));
          if (resp['error'] == false) {
            if (resp['data'].length > 0) {

              this.hr_note_sheet = JSON.parse(resp['data'][0]['remark'])['body']
              this.hr_notesheet_language = resp['data'][0]['language'] === "Hindi" ? true : false
              // this.previou

            }
            // this.emp_arr_Sal_Data = []
            // this.emp_arr_Sal_Data = resp['sal_data']


          }

          break;
        }



      case "ENQUIRY":
        {
          this.log_message = 'APPROVAL LOG OF - ENQUIRY';
          this.previous_log_message = "PREVIOUS APPROVAL LOG OF - ENQUIRY"
          let obj: any = new Object();
          obj['id'] = element.doc_local_no
          obj['b_acct_id'] = this.erpUser.b_acct_id;
          obj['doc_type'] = "ENQUIRY"
          obj['module_cd'] = "HR"
          obj['node_cd'] = element.node_cd
          obj["life_cycle_status"] = "ENQUIRY"

          this.hr_note_sheet = ""
          this.hr_notesheet_language = true

          const resp = await this.eventGroupService.getHrNotesheet(JSON.stringify(obj));
          if (resp['error'] == false) {
            if (resp['data'].length > 0) {

              this.hr_note_sheet = JSON.parse(resp['data'][0]['remark'])['body']
              this.hr_notesheet_language = resp['data'][0]['language'] === "Hindi" ? true : false

            }
            // this.emp_arr_Sal_Data = []
            // this.emp_arr_Sal_Data = resp['sal_data']


          }

          break;
        }
      case "PROBATION":
        {
          this.log_message = 'APPROVAL LOG OF - PROBATION';
          this.previous_log_message = "PREVIOUS APPROVAL LOG OF - PROBATION"
          let obj: any = new Object();
          obj['id'] = element.doc_local_no
          obj['b_acct_id'] = this.erpUser.b_acct_id;
          obj['doc_type'] = "PROBATION"
          obj['module_cd'] = "HR"
          obj['node_cd'] = element.node_cd
          obj["life_cycle_status"] = "PROBATION"

          this.hr_note_sheet = ""
          this.hr_notesheet_language = true

          const resp = await this.eventGroupService.getHrNotesheet(JSON.stringify(obj));
          if (resp['error'] == false) {
            if (resp['data'].length > 0) {

              this.hr_note_sheet = JSON.parse(resp['data'][0]['remark'])['body']
              this.hr_notesheet_language = resp['data'][0]['language'] === "Hindi" ? true : false
              // this.previou


            }
            // this.emp_arr_Sal_Data = []
            // this.emp_arr_Sal_Data = resp['sal_data']


          }

          break;
        }

      case "TERMINATE":
        {
          this.log_message = 'APPROVAL LOG OF - TERMINATE';
          this.previous_log_message = "PREVIOUS APPROVAL LOG OF - TERMINATE"
          let obj: any = new Object();
          obj['id'] = element.doc_local_no
          obj['b_acct_id'] = this.erpUser.b_acct_id;
          obj['doc_type'] = 'TERMINATE'
          obj['module_cd'] = "HR"
          obj['node_cd'] = element.node_cd
          obj["life_cycle_status"] = 'UNDER APPROVED'

          this.hr_note_sheet = ""
          this.hr_notesheet_language = true

          const resp = await this.eventGroupService.getHrNotesheet(JSON.stringify(obj));
          if (resp['error'] == false) {
            if (resp['data'].length > 0) {

              this.hr_note_sheet = JSON.parse(resp['data'][0]['termination_note'])['body']
              this.hr_notesheet_language = resp['data'][0]['language'] === "Hindi" ? true : false
              // this.previou
            }
            // this.emp_arr_Sal_Data = []
            // this.emp_arr_Sal_Data = resp['sal_data']


          }

          break;
        }
      case "RESIGN":
        {
          this.log_message = 'APPROVAL LOG OF - RESIGN';
          this.previous_log_message = "PREVIOUS APPROVAL LOG OF - RESIGN"
          let obj: any = new Object();
          obj['id'] = element.doc_local_no
          obj['b_acct_id'] = this.erpUser.b_acct_id;
          obj['doc_type'] = "RESIGN"
          obj['module_cd'] = "HR"
          obj['node_cd'] = element.node_cd


          this.hr_note_sheet = ""
          this.hr_notesheet_language = true

          const resp = await this.eventGroupService.getHrNotesheet(JSON.stringify(obj));
          if (resp['error'] == false) {
            if (resp['data'].length > 0) {

              this.hr_note_sheet = JSON.parse(resp['data'][0]['remark'])['body']
              this.hr_notesheet_language = resp['data'][0]['language'] === "Hindi" ? true : false
              // this.previou

            }
            // this.emp_arr_Sal_Data = []
            // this.emp_arr_Sal_Data = resp['sal_data']


          }

          break;
        }

      default: this.log_message = "APPROVAL LOG "
        break;
    }


    this.current_task_data = {}
    this.current_task_data = element
    this.PrintObj = {}
    this.PrintObj = element
    let obj: any = {}
    obj["b_acct_id"] = this.b_acct_id;
    obj["doc_local_no"] = element.doc_local_no
    obj['module_cd'] = element.module_cd
    obj['doc_type'] = element.doc_type
    this.spinner.show();
    var resp = await this.mainService.getWorkflowlog(JSON.stringify(obj));
    if (resp['error'] == false) {
      let obj: any = {};
      obj["id"] = element["doc_local_no"];
      obj["b_acct_id"] = this.b_acct_id;
      obj["work_id"] = element["node_cd"];

      if (this.currentObject['doc_type'] == "SALARY_BILL" || this.currentObject['doc_type'] == "DA_ARREAR_BILL") {
        this.currentObject['node_cd'] = JSON.parse(this.currentObject['node_cd'])
      }

      let workflowObj: any = {}
      workflowObj['b_acct_id'] = this.erpUser.b_acct_id
      workflowObj['status'] = 'ACTIVE'
      workflowObj['doc_type'] = this.currentObject['doc_type']
      workflowObj['module_cd'] = this.currentObject['module_cd']
      const module_workflow = await this.mainService.getWorkflows(JSON.stringify(workflowObj))

      if (module_workflow.error === false && module_workflow.data.length === 0) {

        swal.fire('INFO', 'Workflow has not been created yet', 'info')
        this.spinner.hide();
        return;
      }


      await this.ApprovalUserService.getWorkflowloguser(this.erpUser, this.currentObject)
      for (let i = 0; i < this.ApprovalUserService.workflowuser.length; i++) {
        this.UserObj[this.ApprovalUserService.workflowuser[i]['user_id']] = this.ApprovalUserService.workflowuser[i]['emp_name']

      }
      for (let i = 0; i < resp.data.length; i++) {
        if (resp.data[i]["user_id"] == -1) {
          resp.data[i]["name"] = "Contractor"; //this.partyObj[resp['data'][i]['vendor_id']]
          resp.data[i]["role_cd"] = "Contractor";
          resp.data[i]["user_id"] = resp["data"][i]["vendor_id"];
          resp.data[i]["is_vendor"] = true;
          continue;
        }
        for (let j = 0; j < this.ApprovalUserService.workflowuser.length; j++) {
          if (
            resp.data[i]["user_id"] ==
            this.ApprovalUserService.workflowuser[j]["user_id"] &&
            resp.data[i]["role_cd"] ==
            this.ApprovalUserService.workflowuser[j]["role_cd"]
          ) {
            resp.data[i]["name"] =
              this.ApprovalUserService.workflowuser[j]["emp_name"];
            resp.data[i]["role_cd"] =
              this.ApprovalUserService.workflowuser[j]["role_cd"];
          }
        }
        if (resp.data[i]["name"] == undefined) {
          resp.data[i]["name"] = "";
        }
      }
      this.statusArr = resp['data'];
      this.statusArr.map((x: any) => {

        if (x['remark'] == null || x['remark'] == "" || x['remark'] == undefined) {
          x['remark'] = 'No Remark '
          x['language'] = 'English'
        }

        if (x && 'remark' in x) {
          try {
            const parsedRemark = JSON.parse(x['remark']);
            if (typeof parsedRemark === 'object' && 'body' in parsedRemark) {
              x['remark'] = parsedRemark['body'];
            }
          } catch (e) {


          }
        }
      })

      // $('#remark_view').modal('show');
      this.remark_view = true
      this.button_flag = true
      this.multiple_view = false
      this.approval_flag = false
      this.reject_flag = false
      this.task_list = false
      this.spinner.hide()
    } else {
      this.spinner.hide();
      swal.fire("Error", "Error while getting status");
    }
  }

  // Ng modal callc 

  async getAllTaskOfUser() {
    this.allTaskArr = []
    var obj = Object()
    obj['b_acct_id'] = this.erpUser.b_acct_id
    obj['user_id'] = this.erpUser.user_id
    obj["status"] = 'PENDING'
    var resp = await this.mainService.getAllTaskOfUser(JSON.stringify(obj))
    if (resp['error'] == false) {
      this.allTaskArr = resp['data']
      this.allTaskArr.map((x: any) => {
        if (x['doc_type'] === "BP") {
          this.bank_payment_button = true
          x['checked'] = false
        }
      })
      this.mainService.count = this.allTaskArr.length
    } else {
      swal.fire("Error", resp['data'], 'error');
    }
  }
  assignedWorks: any = {};
  // async getAllHeadRecord() {
  //   this.spinner.show();
  //   var work_ids: any = []
  //   work_ids = Object.values(this.embCommonDataService.assignedWork);
  //   for (var i = 0; i < work_ids.length; i++) {
  //     this.assignedWorks[work_ids[i]] = 1;
  //   }
  // }
  // workArr: any = [];
  // workObj: any = {}
  // async getAllWorkInfo() {

  //   var obj: any = new Object();
  //   obj['b_acct_id'] = this.b_acct_id;
  //   this.spinner.show()
  //   var resp = await this.masterDataService.getWorkInfo(JSON.stringify(obj));
  //   if (resp['error'] == false) {
  //     var dt: any = [];
  //     var temp: any = resp['data'];
  //     for (var i = 0; i < temp.length; i++) {
  //       if (this.assignedWorks[temp[i]['id']] != undefined) {
  //         dt.push(temp[i])
  //       }
  //     }
  //     this.workArr = dt;
  //     this.workObj = new Object()
  //     for (let i = 0; i < this.workArr.length; i++) {
  //       this.workArr[i]['desc'] = this.workArr[i]['work_order_no'] + " - " + this.workArr[i]['work_order_name'];
  //       this.workObj[this.workArr[i]['id']] = this.workArr[i]
  //     }
  //     this.spinner.hide();
  //   } else {
  //     this.spinner.hide();
  //     Swal.fire("opps", "Error while getting work info");
  //   }

  // }

  party: any = [];
  partyObj: any = {};
  async getparty() {
    this.spinner.show();
    var resp = await this.portal_main.getAllparties(this.b_acct_id);
    if (resp["error"] == false) {
      this.party = resp.data;
      this.partyObj = new Object();
      for (let i = 0; i < this.party.length; i++) {
        this.partyObj[this.party[i]["rep_le_id"]] =
          this.party[i]["party_leagal_name"];
      }

      this.spinner.hide();

    } else {
      this.spinner.hide();
      Swal.fire("Error", "Error while getting Vendor Info", "error");
    }
  }



  // --- end ng modal 



  //reject 
  rejectdata: any = {}
  backrowdata: any = {}
  async reject() {

    await this.editorService.clearTetx();
    this.editorService.language = 'English'
    this.editorService.class_hindi = false
    this.clearSeletedData2();
    let element = this.current_task_data
    this.rejectdata = Object.assign({}, element)
    var obj = Object.assign({}, {})

    await this.ApprovalUserService.getWorkflowlogbydocno(this.erpUser, element)
    this.ApprovalUserService.workflowlogall = this.ApprovalUserService.workflowlogall.reverse()
    // if (this.current_task_data['module_cd'] === "ACCOUNT" && this.current_task_data['level'] === 1) {

    // } else {
    if (this.ApprovalUserService.workflowlogall?.[1]?.['status'] != 'REJECTED' && this.ApprovalUserService.workflowlogall?.[1]?.['status'] != 'ACCOUNT_REJECTED') {
      if (this.ApprovalUserService.workflowlogall?.[1]?.['status'] == 'REVOKED' || this.ApprovalUserService.workflowlogall?.[1]?.['user_id'] == -1) {
        for (let i = 0; i < this.ApprovalUserService?.workflowlogall?.length; i++) {
          if (this.ApprovalUserService.workflowlogall[i]['user_id'] == -1) continue;
          if (this.ApprovalUserService.workflowlogall[i]['level'] <= element['level'] && this.ApprovalUserService.workflowlogall[i]['branch'] <= element['branch'] && (this.ApprovalUserService.workflowlogall[i]['status'] == 'APPROVED')) {

            obj = this.ApprovalUserService.workflowlogall[i]
            break;


          }


        }
      } else {
        obj = this.ApprovalUserService.workflowlogall[1]
      }

    } else {
      for (let i = 0; i < this.ApprovalUserService.workflowlogall.length; i++) {
        if (this.ApprovalUserService.workflowlogall[i]['user_id'] == -1) continue;
        if (this.ApprovalUserService.workflowlogall[i]['level'] <= element['level'] && this.ApprovalUserService.workflowlogall[i]['branch'] <= element['branch'] && (this.ApprovalUserService.workflowlogall[i]['status'] == 'APPROVED')) {
          if (this.ApprovalUserService.workflowlogall[i]['user_id'] == element['user_id'] && this.ApprovalUserService.workflowlogall[i]['role_cd'] == element['role_cd']) {

            if (this.ApprovalUserService.workflowlogall[i + 1] == undefined && this.rejectdata['doc_type'] == "DEFENDANT DOCS" && this.rejectdata['module_cd'] == 'ICMS') {
              // await this.finalreject()
              return;
            }
            if (this.ApprovalUserService.workflowlogall[i + 1] == undefined) {
              break;

            }
            else {
              if (this.ApprovalUserService.workflowlogall[i + 1]['user_id'] == -1) {
                obj = this.ApprovalUserService.workflowlogall[i + 2]
                break;
              } else {
                obj = this.ApprovalUserService.workflowlogall[i + 1]
                break;
              }
            }


          }

        }


      }
      // }
    }
    this.backrowdata = Object.assign({}, obj)

    // $('#myModal3').modal('show');
    this.reject_flag = true
    this.button_flag = false
    // this.remark_view = true
    this.approval_flag = false
    this.task_list = false
    this.isRejectButtonActive = true

  }

  // async finalreject() {
  //   var obb :any = new Object();
  //   obb['b_acct_id'] = this.erpUser.b_acct_id
  //   obb['module_cd'] = this.rejectdata['module_cd']
  //   obb['status'] = 'REJECTED'
  //   obb['doc_type'] = this.rejectdata['doc_type']
  //   obb['id'] = this.rejectdata['id']
  //   var resp = await this.mainService.updatetask(obb)
  //   if (resp['error'] == false) {
  //     await this.updatestatus(this.rejectdata['doc_local_no'], 'REJECTED')
  //     await this.getAllTaskOfUser()
  //     Swal.fire("Success", "Rejected Successfully!!", 'success');

  //   }
  //   else {
  //     Swal.fire('ERROR', resp['data'], 'error');
  //   }



  // }

  // async updatestatus(id, status) {
  //   var obb :any = new Object()
  //   obb['b_acct_id'] = this.erpUser.b_acct_id
  //   obb['id'] = id
  //   obb['update_user_id'] = this.erpUser.user_id
  //   obb['status'] = status
  //   this.spinner.show();
  //   let resp = await this.liti.updateevidancesList(obb);

  //   if (resp['error'] == false) {

  //     this.spinner.hide();
  //   } else {
  //     this.spinner.hide();
  //     Swal.fire('ERROR', resp['data'], 'error');


  //   }
  // }



  async rejectdoc() {
    let obj = Object()
    obj['b_acct_id'] = this.b_acct_id
    obj['doc_local_no'] = this.rejectdata['doc_local_no']
    var resp = await this.mainService.getembxrefappr(JSON.stringify(obj))
    if (resp['error'] == false) {
      await this.rejectdocstatus(JSON.parse(resp['data'][0]['data']))
    } else {
      swal.fire("Error", resp['data'], 'error');
    }
  }

  // async print_emb_for_bill(element: any) {
  //   this.spinner.show();
  //   var obj = Object();
  //   obj["b_acct_id"] = this.erpUser.b_acct_id;
  //   obj["id"] = element.doc_local_no;
  //   var ebill = await this.ebillService.getBill(JSON.stringify(obj));
  //   if (ebill['error'] == false) {
  //     if (ebill.data.length != 0) {
  //       await this.embPrintService.print1(ebill.data[0]['emb_no'], element['node_cd'])
  //     } else {
  //       swal.fire("warning", "EMB not Found", 'warning')
  //     }
  //   } else {
  //     swal.fire("warning", "EMB not Found", 'warning')
  //   }
  //   this.spinner.hide();
  // }
  async rejectdocstatus(idarr: any) {
    var obj = Object()
    obj['b_acct_id'] = this.b_acct_id
    obj['id'] = idarr
    obj['update_user_id'] = this.erpUser.user_id
    obj['status'] = 'REJECTED'
    var resp = await this.mainService.changestatus(obj)
    if (resp['error'] == false) {

    } else {
      swal.fire("Error", resp['data'], 'error');
    }
  }



  clearSeletedData() {
    // this.textContent.nativeElement.innerHTML = ""
    //   $('#myModal2').modal('hide');
    this.isApprovalButtonActive = false;
    this.editorService.language = "English"
    this.editorService.class_hindi = false
    this.hindi_text_flag = false;
  }
  isRejectButtonActive: boolean = false;
  clearSeletedData2() {
    // this.textContent2.nativeElement.innerHTML = ""
    //  $('#myModal3').modal('hide');
    this.editorService.language = "English";
    this.editorService.class_hindi = false
    this.hindi_text_flag = false;
    this.isRejectButtonActive = false
  }



  // Avinash 
  async rejectExtraWorkStatus() {
    let obj: any = new Object();
    obj['b_acct_id'] = this.b_acct_id;
    obj['update_user_id'] = this.erpUser.user_id
    obj['doc_local_no'] = this.rejectdata['doc_local_no']
    obj['status'] = 'REJECTED'
    let resp = await this.mainService.rejectExtraWork(obj)
    if (resp['error'] == false) {

    } else {
      swal.fire("Error", resp['data'], 'error');
    }
  }





  async rejectedapproval() {
    // return;
    let showError = false;
    try {
      const parsed = JSON.parse(this.editorService.to_data);
      const textOnly = parsed.body
        .replace(/<!--[\s\S]*?-->/g, '') //invisble comment
        .replace(/&nbsp;/g, '')          //invisible spaces(&nbsp)  
        .replace(/<[^>]*>/g, '')         // Remove all the tags
        .trim();

      if (textOnly.length === 0) {
        showError = true;
      }

    } catch (error) {
      showError = true;
    }
    if (showError) {
      swal.fire('Info', 'Please write Notesheet!', 'info');
      this.spinner.hide();
      return;
    }
    if (this.current_task_data['level'] === 1 && this.current_task_data['branch'] === 1 && (this.current_task_data['module_cd'] === "ACCOUNT" || this.current_task_data['module_cd'] === "OPERATION")) {
      this.remark_note = this.editorService.to_data;
      // if (this.remark_note == null) {
      //   Swal.fire('Info', "Please fill Mandatory Details", 'info');
      //   return
      // }

      let lang = this.editorService.language
      // if (this.editorService.language == 'Hindi') {
      //   lang = 'Hindi'
      // } else {
      //   lang = 'English'
      // }

      let resp: any = {}
      //  const resp =  await this.processDocumentService.crossModuleRejection(this.current_task_data );
      if (this.current_task_data['module_cd'] === "ACCOUNT") {
        resp = await this.processDocumentService.crossModuleRejection({ ...this.current_task_data, remark_note: this.remark_note, language: lang })
      } else if (this.current_task_data['module_cd'] === "OPERATION") {
        resp = await this.mainService.crossModuleRejection({ ...this.current_task_data, remark_note: this.remark_note, language: lang, b_acct_id: this.b_acct_id })
      }
      if (resp.error == false) {

        // .then((resp) => {
        //   if(resp.data.length ===0) throw "GO BACK " 
        //   return this.rejectnewrowapproval(resp.data[0], resp.data[0]);
        // }).then((resp2) => console.log(resp2)).catch(error=>{console.log(error);
        // })
        swal.fire('SUCCESS', 'Rejected Successfully', 'success')
        await this.editorService.clearTetx();
        await this.getAllTaskOfUser();
        this.backToList();
        this.editorService.language = 'English'
        this.editorService.class_hindi = false
        this.spinner.hide()
      } else {

        this.spinner.hide()
        swal.fire('ERROR', resp.data, 'error')
        return
      }

    } else {
      await this.rejectnewrowapproval(this.backrowdata, this.rejectdata)
    }
  }
  async rejectnewrowapproval(element: any, obj: any) {
    this.remark_note = this.editorService.to_data
    // let str = this.remark_note.trim()
    // if (str.length < 1) {
    // if (this.remark_note == null) {
    //   Swal.fire('Info', "Please fill Mandatory Details", 'info');
    //   return
    // }
    this.spinner.show()
    let obb = Object()

    obb['user_id'] = element['user_id']
    obb["user_name"] = element['user_name'];
    obb['b_acct_id'] = this.erpUser.b_acct_id
    obb['forwarded_by'] = this.erpUser.user_id
    obb['forward_msg'] = this.remark_note
    obb['remark'] = ""
    obb['status'] = 'PENDING'
    obb['doc_type'] = element['doc_type']//'EBILL'
    obb['doc_local_no'] = element['doc_local_no']
    obb['doc_desc'] = element['doc_desc']
    obb['role_cd'] = element['role_cd']
    obb['module_cd'] = element['module_cd'] //'EMB'
    obb['node_cd'] = element.doc_type === "SALARY_BILL" || element.doc_type === "DA_ARREAR_BILL" ? JSON.parse(element['node_cd']) : element['node_cd']
    obb['level'] = element['level']
    obb['branch'] = element['branch']
    obb['field_value'] = element['field_value']
    obb['language'] = this.editorService.language
    //  obb['language'] = this.editorService.language == 'Hindi'
    // if (this.editorService.language == 'Hindi') {
    //   obb['language'] = 'Hindi'
    // } else {
    //   obb['language'] = 'English'
    // }

    const resp = await this.mainService.insertTask(obb)
    if (resp['error'] === false) {
      await this.rejectapproval(obj)
      if (element['doc_type'] == 'EXTRA_WORK') {
        await this.rejectExtraWorkStatus();

      }
      else {

        if (element['doc_type'] == 'EMB') await this.rejectdoc()
        else await this.rejectdocment(obj)
      }
      if (element['doc_type'] == 'SAL_BILL') {

        await this.salbillapprove('REJECTED', element['doc_local_no'])

      }
      if (element['doc_type'] == 'SUSPENSION') {

        await this.ChangestatusSalBill(element['doc_local_no'], 'REJECTED')

      }
      if (element['doc_type'] == 'REAPOINT') {

        await this.Changestatusreapointbill(element['doc_local_no'], 'REJECTED')

      }
      if (element['doc_type'] == 'DEATH') {

        await this.Changedeathstatus(element['doc_local_no'], 'REJECTED')

      }

      if (element['doc_type'] == 'COMPLAINT') {

        await this.Changecomplaintst(element['doc_local_no'], 'REJECTED')

      }

      if (element['doc_type'] == 'ENQUIRY') {

        await this.updatestatusofEnquiry(element['doc_local_no'], 'REJECTED')

      }
      if (element['doc_type'] == 'PROBATION') {

        await this.changeprobationst(element['doc_local_no'], 'REJECTED')

      }
      if (element['doc_type'] == 'DA_ARREAR') {

        await this.statusChangeForDABILL(element['doc_local_no'], 'REJECTED')

      }
      if (element['doc_type'] == 'TERMINATE') {

        // await this.updatestatusofEnquiry(element['doc_local_no'], 'REJECTED')
        await this.updatestatusoftermination(element['doc_local_no'], 'REJECTED')
      }
      if (element['doc_type'] == 'RESIGN') {

        // await this.updatestatusofEnquiry(element['doc_local_no'], 'REJECTED')
        await this.Changestatusresign(element['doc_local_no'], 'REJECTED')
      }
      await this.getAllTaskOfUser()
      if (this.message_flag == true) await this.getle(this.ApprovalUserService.rolebyid[this.forwarded_user_id]['user_id'], this.ApprovalUserService.userObj[this.erpUser.le_id])
      this.spinner.hide();
      // $('#multiple_view').hide()
      // $('#remark_view').modal('hide');

      this.multiple_view = false
      this.remark_view = false
      this.task_list = true
      this.approval_flag = false
      this.reject_flag = false
      this.ApprovalUserService.workflowlogall = this.ApprovalUserService.workflowlogall.reverse()
      swal.fire("Success", "Rejected Successfully!!", 'success');
      await this.editorService.clearTetx();
      this.editorService.language = 'English'
      this.editorService.class_hindi = false
    } else {
      this.spinner.hide();
      swal.fire("Error", resp['data'], 'error');

    }

  }

  async Changestatusresign(bill_id: any, bill_status_code: any) {
    var obj: any = new Object();
    obj['b_acct_id'] = this.b_acct_id;
    obj['update_user_id'] = this.erpUser.user_id;
    obj['id'] = bill_id;
    obj['status'] = bill_status_code;
    // obj['bill_status_code'] = "UNDERAPPROVAL";
    // obj['bill_status_code'] = "APPROVED";
    this.spinner.show();
    var resp = await this.payableService.Changestatusresign(obj);
    if (resp['error'] == false) {
      //await this.sendToApproval(resp['data']);
      // setTimeout(async () => {
      //   // await this.getAllSuspended();
      //   await this.getResignedEmployee()
      //   this.spinner.hide();
      //   Swal.fire('Success', 'Bill Send Successfully');
      // }, 1000);
      // await this.editorService.clearTetx()
      // this.isApprovalActive = false
    } else {
      this.spinner.hide();
      Swal.fire('Error', 'Error in Bill Generation', 'error');
    }

  }

  async updatestatusoftermination(bill_id: any, bill_status_code: any) {
    var obj: any = new Object();
    obj['b_acct_id'] = this.b_acct_id;
    obj['update_user_id'] = this.erpUser.user_id;
    obj['enquiry_id'] = bill_id;
    obj['status'] = bill_status_code;
    // obj['bill_status_code'] = "UNDERAPPROVAL";
    // obj['bill_status_code'] = "APPROVED";
    this.spinner.show();
    var resp = await this.payableService.updatestatusoftermination(obj);
    if (resp['error'] == false) {
      //await this.sendToApproval(resp['data']);
      setTimeout(async () => {

        // await this.getAllComplaint()
        this.spinner.hide();
        Swal.fire('Success', 'Bill Send Successfully');
      }, 1000);
      // await this.getEnquiry()
      await this.editorService.clearTetx()

    } else {
      this.spinner.hide();
      Swal.fire('Error', 'Error in Bill Generation', 'error');
    }

  }


  async changeprobationst(bill_id: any, bill_status_code: any) {
    var obj: any = new Object();
    obj['b_acct_id'] = this.b_acct_id;
    obj['update_user_id'] = this.erpUser.user_id;
    obj['id'] = bill_id;
    obj['probation_status_code'] = bill_status_code;
    // obj['bill_status_code'] = "UNDERAPPROVAL";
    // obj['bill_status_code'] = "APPROVED";
    this.spinner.show();
    var resp = await this.payableService.changeprobationst(obj);
    if (resp['error'] == false) {
      //await this.sendToApproval(resp['data']);
      setTimeout(async () => {
        // await this.getAllSuspended();
        await this.getAllEmployees()

        this.spinner.hide();
        Swal.fire('Success', 'Bill Send Successfully');
      }, 1000);
      await this.editorService.clearTetx()

    } else {
      this.spinner.hide();
      Swal.fire('Error', 'Error in Bill Generation', 'error');
    }

  }

  async rejectapproval(element: any) {
    this.spinner.show()
    let obb: any = new Object();
    obb['b_acct_id'] = this.erpUser.b_acct_id
    obb['remark'] = this.remark_note
    obb['status'] = 'REJECTED'
    obb['id'] = element['id']
    obb['doc_type'] = element.doc_type
    if (this.editorService.language == 'Hindi') {

      obb['language'] = 'Hindi'
    } else {
      obb['language'] = 'English'
    }
    var resp = await this.mainService.updatetask(obb)
    if (resp['error'] == false) {
      this.spinner.hide();
    } else {
      this.spinner.hide();
      swal.fire("Error", resp['data'], 'error');
    }

  }
  async rejectdocment(element: any) {
    this.spinner.show()
    var obb: any = new Object();
    obb['b_acct_id'] = this.erpUser.b_acct_id
    obb['module_cd'] = element['module_cd']
    obb['status'] = 'REJECTED'
    obb['doc_type'] = element['doc_type']
    obb['doc_local_no'] = element['doc_local_no']
    obb['remark'] = this.remark_note

    var resp = await this.mainService.updateWorkflowDocumentStatus(obb)
    if (resp['error'] == false) {
      this.spinner.hide();
    } else {
      this.spinner.hide();
      swal.fire("Error", resp['data'], 'error');
    }

  }




  selectedTender: any = {}
  isApprovalButtonActive: boolean = false
  async Appr() {
    await this.editorService.clearTetx();
    this.forwarded_user_id = null;
    this.editorService.language = 'English'
    this.editorService.class_hindi = false

    let element: any = JSON.parse(JSON.stringify(this.current_task_data))
    this.tender_apprdata = JSON.parse(JSON.stringify(element))

    if (element.doc_type == 'ACR' && this.acrValid == false) {

      swal.fire('Info', 'Go to ACR Component Add Your Report and then Approve ', 'info');
      return;

    }
    if (element.doc_type == 'ACR' && this.acrValid == true && element.doc_local_no != history.state['key1']) {
      swal.fire('Info', ` You Can Approve only in ACR Document No ${history.state['key1']} at this time`);
      return
    }
    let obj: any = {}
    if (element.doc_type == "BP" && element.module_cd === "ACCOUNT") {

      this.remark_note = ""
      this.tender_apprdata = JSON.parse(JSON.stringify(element))
    } else if (element.doc_type == "SALARY_BILL" || element.doc_type == "DA_ARREAR_BILL" && element.module_cd === "ACCOUNT") {
      element.node_cd = JSON.parse(element.node_cd)

      this.tender_apprdata = JSON.parse(JSON.stringify(element))
    }
    else if (element.doc_type == "DA_ARREAR" && element.module_cd === "HR") {
      if (typeof element.node_cd == 'string') {
        element.node_cd = JSON.parse(element.node_cd)

      } else {
        element.node_cd = element.node_cd

      }

      this.tender_apprdata = JSON.parse(JSON.stringify(element))
    }
    else {
      obj['id'] = element['doc_local_no']
      obj['work_id'] = element['node_cd'];
      this.tender_apprdata = JSON.parse(JSON.stringify(element))
    }


    await this.getundertakings(this.tender_apprdata)
    await this.ApprovalUserService.getWorkflowlog(this.erpUser, this.tender_apprdata['doc_type'], this.tender_apprdata['module_cd'])
    await this.ApprovalUserService.getMostLatestWorkflowlog(this.erpUser, this.tender_apprdata)

    this.remark_note = ""

    // $('#myModal2').modal('show');
    // this.remark_view = true
    this.approval_flag = true
    this.button_flag = false
    this.reject_flag = false
    this.task_list = false
    this.isApprovalButtonActive = true;
    await this.ApprovalUserService.getWorkflowloguser(this.erpUser, this.tender_apprdata)
  }



  //udertakings************************************//
  async getundertakings(element: any) {
    var obj: any = new Object()
    obj['b_acct_id'] = this.b_acct_id
    obj['module_cd'] = element['module_cd'] // 'EMB'
    obj['doc_type'] = element['doc_type'] // 'EBILL'
    obj['role_cd'] = element['role_cd']
    var resp = await this.mainService.getundertakingsWithWorkflow(JSON.stringify(obj))
    if (resp['error'] == false) {
      this.spinner.hide();
      if (resp['data'].length > 0) {
        this.undertakings = JSON.parse(resp['data'][0]['data'])
      }
    } else {
      this.spinner.hide();
    }

  }
  forwarded_user_id: any
  tender_apprdata: any = {}
  appr_remark: any
  async Approvedapproval() {


    this.remark_note = this.editorService.to_data
    // let str = this.remark_note.trim()
    // if (str.length < 1) {
    // if (this.remark_note == null) {

    //   Swal.fire('Info', "Please fill Mandatory Details", 'info');
    //   return
    // }
    let showError = false;
    if (!this.forwarded_user_id) {
      this.spinner.hide();
      swal.fire('Info', 'Please select User!', 'info');
      return;
    }
    try {
      const parsed = JSON.parse(this.editorService.to_data);
      const textOnly = parsed.body
        .replace(/<!--[\s\S]*?-->/g, '') //invisble comment
        .replace(/&nbsp;/g, '')          //invisible spaces(&nbsp)  
        .replace(/<[^>]*>/g, '')         // Remove all the tags
        .trim();

      if (textOnly.length === 0) {
        showError = true;
      }

    } catch (error) {
      showError = true;
    }
    if (showError) {
      swal.fire('Info', 'Please write Notesheet!', 'info');
      this.spinner.hide();
      return;
    }
    this.spinner.show()
    if (this.forwarded_user_id != null || this.ApprovalUserService.vendorflag == true) {
      var obb: any = new Object();
      if (this.forwarded_user_id == null && this.ApprovalUserService.vendorflag == true) {
        obb['user_id'] = -1
        if (this.selectedTender['party_id'] == null || this.selectedTender['party_id'] == undefined) {
          swal.fire("Error", "Please Map Verdor with Work..!", 'error');
          return
        }
        obb['vendor_id'] = this.selectedTender['party_id']
      } else {
        obb['user_id'] = this.ApprovalUserService.rolebyid[this.forwarded_user_id]['user_id']
      }
      if (obb["user_id"] == -1) {
        let userData: any = {};
        userData['b_acct_id'] = this.b_acct_id;
        userData['user_id'] = obb["vendor_id"];
        let venderInfo = await this.mainService.getVenderName(JSON.stringify(obb));
        if (venderInfo["error"] == false) {
          obb['user_name'] = venderInfo["data"]['party_leagal_name']
        }
      } else {
        for (let i = 0; i < this.ApprovalUserService.workuser.length; i++) {
          if (this.ApprovalUserService.workuser[i]['user_id'] == obb["user_id"]) {
            let h = this.ApprovalUserService.workuser[i]['desc'].split("-");
            obb['user_name'] = h[1];
          }
        }
      }


      if (this.tender_apprdata['doc_type'] == "BP") {
        let data: any = []
        let id_arr: any = []
        let doc_loca_arr: any = []
        let node_cd_arr: any = []
        this.allTaskArr.map((x: any) => {
          if (x['doc_type'] == "BP" && x['checked'] == true) {
            id_arr.push(x['id'])
            doc_loca_arr.push(x['doc_local_no'])
            node_cd_arr.push(x['node_cd'])
            data.push({
              id: x['doc_local_no'], // additional_property autoincrement id
              doc_desc: x['doc_desc'],
              node_cd: x['node_cd'],
            })
          }
        })
        obb['data'] = data;
        this.tender_apprdata['id'] = id_arr
        this.tender_apprdata['doc_local_no'] = doc_loca_arr
        this.tender_apprdata['node_cd'] = node_cd_arr
      } else {
        obb['doc_local_no'] = this.tender_apprdata['doc_local_no']
        obb['doc_desc'] = this.tender_apprdata['doc_desc']
        obb['node_cd'] = this.tender_apprdata['node_cd']
      }
      // if (this.selectedLang == 'Hindi') {
      //   obb['language'] = 'Hindi'
      // } else {
      //   obb['language'] = 'English'
      // }
      obb['language'] = this.editorService.language
      obb['b_acct_id'] = this.erpUser.b_acct_id
      obb['forwarded_by'] = this.erpUser.user_id
      obb['forward_msg'] = this.remark_note
      obb['remark'] = ""
      obb['status'] = 'PENDING'
      obb['doc_type'] = this.tender_apprdata['doc_type']//'EBILL'
      // obb['doc_local_no'] = this.tender_apprdata['doc_local_no']
      // obb['doc_desc'] = this.tender_apprdata['doc_desc']
      obb['undertaking'] = this.tender_apprdata['undertaking']
      obb['module_cd'] = this.tender_apprdata['module_cd'] //'EMB'
      // obb['node_cd'] = this.tender_apprdata['node_cd']
      if (this.ApprovalUserService.vendorflag == true) {
        obb['level'] = this.tender_apprdata['level']
        obb['branch'] = this.tender_apprdata['branch']
      }
      else {
        obb['role_cd'] = this.ApprovalUserService.rolebyid[this.forwarded_user_id]['role_cd']
        obb['level'] = this.ApprovalUserService.rolebyid[this.forwarded_user_id]['level']
        obb['branch'] = this.ApprovalUserService.rolebyid[this.forwarded_user_id]['branch']
      }

      obb['field_value'] = this.tender_apprdata['field_value']

      var resp = await this.mainService.insertTask(obb)
      if (resp['error'] == false) {
        await this.pendingapproval()
        if (this.tender_apprdata['doc_type'] == 'EMB') await this.embdoc('UNDERAPPROVAL')
        if (this.tender_apprdata['doc_type'] == 'SUSPENSION') await this.ChangestatusSalBill(this.tender_apprdata['doc_local_no'], 'APPROVED')
        if (this.tender_apprdata['doc_type'] == 'REAPOINT') await this.Changestatusreapointbill(this.tender_apprdata['doc_local_no'], 'REAPOINTMENT')
        if (this.tender_apprdata['doc_type'] == 'DEATH') await this.Changedeathstatus(this.tender_apprdata['doc_local_no'], 'DEATH')
        if (this.tender_apprdata['doc_type'] == 'TRANSFER') await this.Changedeathstatus(this.tender_apprdata['doc_local_no'], 'TRANSFERRED')
        if (this.tender_apprdata['doc_type'] == 'COMPLAINT') await this.Changecomplaintst(this.tender_apprdata['doc_local_no'], 'REGISTERED')
        if (this.tender_apprdata['doc_type'] == 'ENQUIRY') await this.updatestatusofEnquiry(this.tender_apprdata['doc_local_no'], 'IN PROCESS')
        if (this.tender_apprdata['doc_type'] == 'TERMINATE') await this.updatestatusoftermination(this.tender_apprdata['doc_local_no'], 'UNDER APPROVED')
        if (this.tender_apprdata['doc_type'] == 'RESIGN') await this.Changestatusresign(this.tender_apprdata['doc_local_no'], 'APPROVED')

        if (this.tender_apprdata['doc_type'] == 'PROBATION') await this.changeprobationst(this.tender_apprdata['doc_local_no'], 'REGISTERED')


        else await this.underapprovalapproval(this.tender_apprdata)
        if (this.ApprovalUserService.conditionflag == true) await this.approvedocmentwithcondition()
        await this.getAllTaskOfUser()
        if (this.forwarded_user_id == null && this.ApprovalUserService.vendorflag == true) {
          if (this.message_flag == true) await this.getle(this.selectedTender['party_id'], this.ApprovalUserService.userObj[this.erpUser.le_id])
        } else {
          if (this.message_flag == true) await this.getle(this.ApprovalUserService.rolebyid[this.forwarded_user_id]['user_id'], this.ApprovalUserService.userObj[this.erpUser.le_id])

        }
        this.spinner.hide();
        if (this.ApprovalUserService.conditionflag == false) {
          // m_avinash 
          if (this.acrValid == true) {
            await this.updateStatusOfACR()
            await this.acrTrackInsert(obb)
          }

          // $('#remark_view').modal('hide');
          // $('#multiple_view').hide()
          this.multiple_view = false
          this.remark_view = false
          this.button_flag = false
          this.task_list = true
          this.approval_flag = false
          this.reject_flag = false
          this.isApprovalButtonActive = false;
          // $('#myModal2').modal('hide');


          swal.fire("Success", "Approval Forwarded Successfully!!", 'success');
          this.editorService.clearTetx();
          this.forwarded_user_id = null;
          this.forwarded_user_id = null;
          this.editorService.language = 'English'
          this.editorService.class_hindi = false
        }

      } else {
        this.spinner.hide();
        swal.fire("Error", resp['data'], 'error');

      }
    } else {
      swal.fire("Error", "Please Select Any User..!", 'error');
      this.spinner.hide();
    }
  }


  remark_note: any = ""
  getAllcontent = (event: any) => {
    this.remark_note = event.target.textContent
  }

  // selectedLang: any = 'English'
  selectedFont: any
  hindi_text_flag: any = false
  mangal_text_flag: any = false
  onChangeLang() {
    // this.hindi_text_flag = true
    if (this.editorService.language == 'Hindi') {
      this.hindi_text_flag = true;
      this.selectedFont = 'Kruti Dev'
    } else {
      this.hindi_text_flag = false;
      this.mangal_text_flag = false;
    }
  }

  // onChangeFont() {
  //   if (this.selectedFont == 'Mangal') {
  //     this.hindi_text_flag = true
  //     // this.mangal_text_flag = true

  //   } else {
  //     this.mangal_text_flag = false
  //     this.hindi_text_flag = true
  //   }
  // }


  message_flag = true
  async getle(user_id: any, user_name: any) {
    let obj = Object()
    obj['b_acct_id'] = this.b_acct_id
    obj['le_id'] = user_id
    let resp = await this.mainService.getcurrentlegalentity(JSON.stringify(obj))
    if (resp['error'] == false) {
      await this.sendmessage(resp['data'][0]['phone_no'], user_name)
      // this.message_flag = false
      this.spinner.hide();

    } else {
      this.spinner.hide();
      swal.fire("Error", resp['data'], 'error');

    }
  }
  async sendmessage(mobile: any, user_name: any) {//mobile, doc_type,doc_number,user_name
    let resp = await this.mainService.sendNotiMsg(mobile, this.tender_apprdata['doc_type'], this.tender_apprdata['doc_local_no'], user_name)
    if (resp['error'] == false) {
      this.spinner.hide();
    } else {
      this.spinner.hide();
      swal.fire("Error", resp['data'], 'error');
    }
  }
  undertakings: any = []
  async pendingapproval() {
    this.spinner.show()
    var obb: any = new Object();
    obb['b_acct_id'] = this.erpUser.b_acct_id
    obb['remark'] = this.remark_note //this.appr_remark
    obb['status'] = 'APPROVED'
    obb['language'] = this.editorService.language
    obb['id'] = this.tender_apprdata['id']
    obb['doc_type'] = this.tender_apprdata['doc_type']
    obb['undertaking'] = this.tender_apprdata['undertaking'] ? this.tender_apprdata['undertaking'] : JSON.stringify([])


    if (this.editorService.language == 'Hindi') {
      obb['language'] = 'Hindi'
    } else {
      obb['language'] = 'English'
    }


    var resp = await this.mainService.updatetask(obb)
    if (resp['error'] == false) {
      this.spinner.hide();
    } else {
      this.spinner.hide();
      swal.fire("Error", resp['data'], 'error');
    }
  }



  async underapprovalapproval(element: any) {
    this.spinner.show()
    var obb: any = new Object();
    obb['b_acct_id'] = this.erpUser.b_acct_id
    obb['status'] = 'UNDERAPPROVAL'
    obb['module_cd'] = this.tender_apprdata['module_cd']
    obb['doc_type'] = this.tender_apprdata['doc_type']
    obb['doc_local_no'] = this.tender_apprdata['doc_local_no']
    var resp = await this.mainService.updateWorkflowDocumentStatus(obb)
    if (resp['error'] == false) {
      this.spinner.hide();
    } else {
      this.spinner.hide();
      swal.fire("Error", resp['data'], 'error');

    }

  }
  // M_AVINASH 


  // change the status of first acr
  async updateStatusOfACR() {
    let obj: any = new Object();
    obj['b_acct_id'] = this.b_acct_id
    if (history.state['role'] == 'off1') // second rank officer
    {

      obj['first_id'] = history.state['key2']
      let resp = await this.acrService.changeStatusOfACRFirst(obj)
    }
    if (history.state['role'] == 'D11' || history.state['role'] == 'E11') {
      obj['first_id'] = history.state['key2']
      // obj['work_id']=history.state['key1'];
      let resp = await this.acrService.changeStatusOfAcrOfficer(obj)
    }

  }


  // CHANge status in acr self final approval 
  async acrDocStatus(status: any) {
    let obj = Object();
    obj['b_acct_id'] = this.b_acct_id;
    obj['doc_loc_no'] = this.tender_apprdata['doc_local_no']
    obj['role_approve'] = 'Approved'
    let resp = await this.acrService.changeStatusOfAcrSelf(obj)
    if (resp['error'] == false) {
      // await this.approvedocment

    }
    else {
      swal.fire("Error", 'Acr Status Not Change', 'error');
    }

  }


  // insert in acr track 
  async acrTrackInsert(obb: any) {
    let obj: any = new Object();
    obj['b_acct_id'] = this.b_acct_id;
    obj['work_id'] = obb.doc_local_no // its same work_id
    obj['user_id_from'] = obb.forwarded_by
    obj['name_from'] = this.erpUser.party_name
    obj['user_id_to'] = obb.user_id // where we send file
    obj['name_to'] = obb.user_name
    obj['direction'] = 'forward';
    obj['flag'] = 1;
    obj['form_no'] = history.state['key3'];
    obj['first_id'] = history.state['key2']
    obj['self_id'] = history.state['self_id']
    if (history.state['review_id'] != undefined) {
      obj['review_id'] = history.state['review_id']
    }
    let resp = await this.acrService.insertAcrTrack(obj);

  }



  //--- m_avinash
  async embdoc(status: any) {
    let obj = Object()
    obj['b_acct_id'] = this.b_acct_id
    obj['doc_local_no'] = this.tender_apprdata['doc_local_no']
    var resp = await this.mainService.getembxrefappr(JSON.stringify(obj))
    if (resp['error'] == false) {
      await this.docstatus(JSON.parse(resp['data'][0]['data']), status)
    } else {
      swal.fire("Error", resp['data'], 'error');
    }
  }
  async docstatus(idarr: any, status: any) {
    var obj = Object()
    obj['b_acct_id'] = this.b_acct_id
    obj['id'] = idarr
    obj['update_user_id'] = this.erpUser.user_id
    obj['status'] = status
    var resp = await this.mainService.changestatus(obj)
    if (resp['error'] == false) {
    } else {
      swal.fire("Error", resp['data'], 'error');
    }
  }


  async approvedocmentwithcondition() {
    this.spinner.show()
    var obb: any = new Object();
    obb['b_acct_id'] = this.erpUser.b_acct_id
    obb['module_cd'] = this.tender_apprdata['module_cd']
    obb['status'] = 'APPROVED'
    obb['doc_type'] = this.tender_apprdata['doc_type']
    obb['doc_local_no'] = this.tender_apprdata['doc_local_no']

    var resp = await this.mainService.updateWorkflowDocumentStatus(obb)
    if (resp['error'] == false) {
      this.spinner.hide();
      swal.fire("Success", "Approved Successfully!!", 'success');
    } else {
      this.spinner.hide();

      swal.fire("Error", resp['data'], 'error');

    }

  }


  async approvedocment() {
    this.remark_note = this.editorService.to_data
    // let str = this.remark_note.trim()
    // if (str.length < 1) {
    if (this.remark_note == null) {
      Swal.fire('Info', "Please fill Mandatory Details", 'info');
      return
    }
    this.spinner.show()
    let doc_loca_arr: any = []


    var obb: any = new Object();
    obb['b_acct_id'] = this.erpUser.b_acct_id
    obb['module_cd'] = this.tender_apprdata['module_cd']
    obb['status'] = 'APPROVED'
    obb['doc_type'] = this.tender_apprdata['doc_type']
    obb['doc_local_no'] = this.tender_apprdata['doc_local_no']
    obb['undertaking'] = this.tender_apprdata['undertaking']


    if (this.tender_apprdata['doc_type'] === "BP" && this.tender_apprdata['module_cd'] === 'ACCOUNT') {
      let id_arr: any = []
      let node_cd_arr: any = []

      this.allTaskArr.map((x: any) => {
        if (x['doc_type'] == "BP" && x['checked'] == true) {
          id_arr.push(x['id'])
          doc_loca_arr.push(x['doc_local_no'])
          node_cd_arr.push(x['node_cd'])
        }
      })
      this.tender_apprdata['id'] = id_arr
      this.tender_apprdata['doc_local_no'] = doc_loca_arr
      this.tender_apprdata['node_cd'] = node_cd_arr
      // await this.insert_jrnl(doc_loca_arr);

      const response = await this.processDocumentService.changeBPSatusInBPandJV(doc_loca_arr)
      if (response.error === true) {
        this.spinner.hide();
        return;
      }
      // await this.updateBpStatusInJrnl(doc_loca_arr)
      this.is_bp_doc = false
    }

    if ((this.tender_apprdata['module_cd'] === 'ACCOUNT') && (this.tender_apprdata['doc_type'] === "SALARY_BILL" || this.tender_apprdata['doc_type'] === "VENDOR_BILL_OPERATION" || this.tender_apprdata['doc_type'] === "ARREAR_BILL" || this.tender_apprdata['doc_type'] === "DA_ARREAR_BILL" || this.tender_apprdata['doc_type'] === "CB_BILL" || this.tender_apprdata['doc_type'] === "PO_REIMBURSEMENT_BILL" || this.tender_apprdata['doc_type'] === "MEDICAL_BILL" || this.tender_apprdata['doc_type'] === "SUBSIDY_BILL" || this.tender_apprdata['doc_type'] === "ACP_ARREAR_BILL" || this.tender_apprdata['doc_type'] === "GRATUITY_BILL" || this.tender_apprdata['doc_type'] === "LEAVE_ENCASHMENT_BILL")) {
      obb['status'] = 'POSTED'
      obb['event_id'] = this.tender_apprdata['doc_local_no']
      // let resp = await this.operationMainService.postJournalData(obb);

      const resonse = await this.processDocumentService.processDepartmentBill(this.tender_apprdata)
      if (resonse) {
        obb['status'] = 'PROCESSED'
      } else {
        // swal.fire('error', 'Error While Posting in Journal', 'error');
        this.spinner.hide();
        return;

      }
    }


    if (this.tender_apprdata['module_cd'] === 'ACCOUNT' && this.tender_apprdata['doc_type'] === "MANUAL_JOURNAL") {
      const resp = await this.processDocumentService.postManualJournal(this.tender_apprdata);
      if (resp) {
        obb['status'] = 'POSTED'
      } else {
        // swal.fire('error', 'Error While Posting in Journal', 'error');
        this.spinner.hide();
        return;
      }
    }
    if (this.tender_apprdata['module_cd'] === 'ACCOUNT' && this.tender_apprdata['doc_type'] === "CB") {
      const resp = await this.processDocumentService.accptedCB(this.tender_apprdata);
      if (resp) {
        obb['status'] = 'APPROVED'
      } else {
        // swal.fire('error', 'Error While Posting in Journal', 'error');
        this.spinner.hide();
        return;
      }
    }
    if (this.tender_apprdata['module_cd'] === 'ACCOUNT' && this.tender_apprdata['doc_type'] === "PO_REIMBURSEMENT") {
      const resp = await this.processDocumentService.acceptPoReimbursement(this.tender_apprdata);
      if (resp) {
        obb['status'] = 'APPROVED'
      } else {
        // swal.fire('error', 'Error While Posting in Journal', 'error');
        this.spinner.hide();
        return;
      }
    }

    // if (this.tender_apprdata['doc_type'] == 'Note Sheet' && this.tender_apprdata['module_cd'] == 'INVENTORY') {
    //   let resp = await this.operationMainService.getnotesheetdetails(JSON.stringify(obb));
    //   if (resp['error'] == false) {
    //     let obj: any = {}
    //     obj['notsheet_id'] = resp['data'][0]['notesheet_id']
    //     obj['user_id'] = this.erpUser.user_id
    //     obj['b_acct_id'] = this.erpUser.b_acct_id
    //     let resp2 = await this.operationMainService.insertrate_discovery(obj);

    //     if (resp2['error'] == true) {
    //       swal.fire('error', 'server side error', 'error');
    //       return
    //     }
    //   } else {
    //     swal.fire('error', 'server side error', 'error');
    //     return
    //   }
    // }

    if (this.tender_apprdata['doc_type'] == 'EMB') {
      await this.embdoc('APPROVED')
      await this.pendingapproval()
      await this.getAllTaskOfUser()
      swal.fire("Success", "EMB Approved Successfully!!", 'success');
      return
    }

    // M_AVINASH
    if (this.tender_apprdata['doc_type'] == 'ACR') {
      await this.acrDocStatus('APPROVED');
      await this.updateStatusOfACR()
      await this.acrTrackApprove()

    }
    // this.ebillPrintService.processflag = false
    // if (this.tender_apprdata['doc_type'] == 'EBILL') {
    //   let res = await this.ebillPrintService.processebill(this.tender_apprdata, this.erpUser)
    // }
    // if (this.tender_apprdata['doc_type'] == 'VENDOR_BILL') {
    //   let res = await this.ebillPrintService.processbill(this.tender_apprdata, this.erpUser)
    // }
    // if (this.tender_apprdata['doc_type'] == 'SUBSIDY') {
    //   let res = await this.ebillPrintService.processSubsidyBill(this.tender_apprdata, this.erpUser)
    // }

    if (this.tender_apprdata['doc_type'] == 'SAL_BILL' || this.tender_apprdata['doc_type'] == 'AA_BILL') {
      await this.salbillapprove('APPROVED', this.tender_apprdata['doc_local_no'])
    }
    if (this.tender_apprdata['doc_type'] == 'DA_ARREAR') {
      await this.statusChangeForDABILL(this.tender_apprdata['doc_local_no'], 'APPROVED')
    }
    if (this.tender_apprdata['doc_type'] == 'SUSPENSION') {
      await this.ChangestatusSalBill(this.tender_apprdata['doc_local_no'], 'APPROVED')
    }
    if (this.tender_apprdata['doc_type'] == 'REAPOINT') {
      await this.Changestatusreapointbill(this.tender_apprdata['doc_local_no'], 'REAPOINTMENT');

    }
    if (this.tender_apprdata['doc_type'] == 'DEATH') {
      await this.Changestatusreapointbill(this.tender_apprdata['doc_local_no'], 'DEATH');

    }
    if (this.tender_apprdata['doc_type'] == 'TRANSFER') {
      await this.Changestatusreapointbill(this.tender_apprdata['doc_local_no'], 'TRANSFERRED');

    }
    if (this.tender_apprdata['doc_type'] == 'COMPLAINT') {
      await this.Changecomplaintst(this.tender_apprdata['doc_local_no'], 'REGISTERED');

    }
    if (this.tender_apprdata['doc_type'] == 'ENQUIRY') {
      await this.updatestatusofEnquiry(this.tender_apprdata['doc_local_no'], 'IN PROCESS');

    }

    if (this.tender_apprdata['doc_type'] == 'TERMINATE') {
      await this.updatestatusoftermination(this.tender_apprdata['doc_local_no'], 'UNDER APPROVED');

    }

    if (this.tender_apprdata['doc_type'] == 'PROBATION') {
      await this.changeprobationst(this.tender_apprdata['doc_local_no'], 'REGISTERED');

    }
    if (this.tender_apprdata['doc_type'] == 'ADV_BILL') {
      await this.statusChangeForADVBILL('APPROVED', this.tender_apprdata['doc_local_no'])
    }
    if (this.tender_apprdata['doc_type'] == 'EXTRA_ARREAR_BILL') {
      await this.statusChangeForextraarrearBILL('APPROVED', this.tender_apprdata['doc_local_no'])
    }
    if (this.tender_apprdata['doc_type'] == 'MED_BILL') {
      await this.statusChangeForMEDBILL('APPROVED', this.tender_apprdata['doc_local_no'])
    }
    // if (this.ebillPrintService.processflag) {
    //   this.spinner.hide();
    //   return;
    // }

    var resp = await this.mainService.updateWorkflowDocumentStatus(obb)
    if (resp['error'] == false) {
      await this.pendingapproval()
      await this.getAllTaskOfUser()
      this.spinner.hide();
      // $('#remark_view').modal('hide');
      this.remark_view = false
      this.approval_flag = false
      this.button_flag = false
      this.reject_flag = false
      this.task_list = true
      this.multiple_view = false
      // $('#multiple_view').hide()
      swal.fire("Success", "Approved Successfully!!", 'success');
    } else {
      this.spinner.hide();
      swal.fire("Error", resp['data'], 'error');
    }
  }


  async Changecomplaintst(bill_id: any, bill_status_code: any) {
    var obj: any = new Object();
    obj['b_acct_id'] = this.b_acct_id;
    obj['update_user_id'] = this.erpUser.user_id;
    obj['id'] = bill_id;
    obj['complaint_status'] = bill_status_code;
    // obj['bill_status_code'] = "UNDERAPPROVAL";
    // obj['bill_status_code'] = "APPROVED";
    this.spinner.show();
    var resp = await this.payableService.changeComplaintStatus(obj);
    if (resp['error'] == false) {
      //await this.sendToApproval(resp['data']);
      setTimeout(async () => {
        // await this.getAllSuspended();

        this.spinner.hide();
        Swal.fire('Success', 'Bill Send Successfully');
      }, 1000);
      await this.editorService.clearTetx()

    } else {
      this.spinner.hide();
      Swal.fire('Error', 'Error in Bill Generation', 'error');
    }

  }



  async ChangestatusSalBill(bill_id: any, bill_status_code: any) {
    var obj: any = new Object();
    obj['b_acct_id'] = this.b_acct_id;
    obj['update_user_id'] = this.erpUser.user_id;
    obj['max_susp_id'] = bill_id;
    obj['status'] = bill_status_code;
    // obj['bill_status_code'] = "UNDERAPPROVAL";
    // obj['bill_status_code'] = "APPROVED";
    obj["data"] = this.emp_arr_Sal_Data
    obj['suspend_st'] = 'SUSPENDED'
    obj["check"] = 'task'
    this.spinner.show();
    var resp = await this.payableService.changeSuspendStatusOfBill(obj);
    if (resp['error'] == false) {
      //await this.sendToApproval(resp['data']);

      // await this.editorService.clearTetx()
    } else {
      this.spinner.hide();
      swal.fire('Error', 'Error in Bill Generation', 'error');
    }

  }


















  async acrTrackApprove() {
    let obj: any = new Object();
    obj['b_acct_id'] = this.b_acct_id;
    obj['name_from'] = this.erpUser.party_name;
    obj['user_id_from'] = this.erpUser.user_id;
    obj['form_no'] = history.state['key3']
    obj['work_id'] = history.state['key1']
    obj['self_id'] = history.state['self_id'];
    obj['first_id'] = history.state['key2'];
    obj['review_id'] = history.state['review_id'];
    obj['direction'] = 'Final Approval'
    let resp = await this.acrService.saveLastApproval(obj);
  }




  allUser: any = [];
  UserObj: any = {};
  async getAllUsersInfo() {
    var obj: any = { b_acct_id: this.b_acct_id };
    var resp: any = await this.userAdd.getAllUsersInfo(JSON.stringify(obj));
    if (resp['error'] == false) {
      this.allUser = resp['data'];
      for (let i = 0; i < this.allUser.length; i++) {
        this.UserObj[this.allUser[i]['user_id']] = this.allUser[i]['first_name'] + " " + this.allUser[i]['last_name']
        this.allUser[i]['name'] = this.allUser[i]['first_name'] + " " + this.allUser[i]['last_name']
      }
    } else {

    }
  }

  lastLevelOfApprovel: any = {};
  async getAllRule() {
    var resp = await this.profileService.getAllApproval(this.b_acct_id);
    if (resp['error'] == false) {
      this.allApproval = resp['data'];
      for (var i = 0; i < this.allApproval.length; i++) {
        this.lastLevelOfApprovel[this.allApproval[i]['doc_type']] = this.allApproval[i]['level_of_approval']
      }
    } else {
    }

  }

  stepStatus: any = {};
  async getAllApprovalStatus() {

    this.mainService.tasks = 0;
    this.stepStatus = {};
    this.allTask = {};
    this.allTaskArr = [];
    var ob: any = new Object();
    ob['b_acct_id'] = this.b_acct_id;
    var resp = await this.profileService.getAllApprovalStatus(ob);
    var unique_local_no = [];

    if (resp['error'] == false) {
      this.allApprovalStatus = resp['data'];

      var temp = [];
      for (let i = 0; i < this.allApprovalStatus.length; i++) {
        this.stepStatus[this.allApprovalStatus[i]['doc_local_no'] + this.allApprovalStatus[i]['level_of_approval']]
          = this.allApprovalStatus[i]['status']
        if (this.allApprovalStatus[i]['user_id'] == this.erpUser['user_id']) {
          temp.push(this.allApprovalStatus[i]);
          unique_local_no.push(this.allApprovalStatus[i]['doc_local_no']);
        }
      }

      this.allApprovalStatus = [];
      this.allApprovalStatus = temp;
      let unique: any = unique_local_no.filter((item, i, ar) => ar.indexOf(item) === i);
      var tableObj: any = {}
      for (let j = 0; j < unique.length; j++) {
        for (var i = 0; i < this.allApprovalStatus.length; i++) {
          if (this.allApprovalStatus[i]['status'] == 'APPROVED' || this.allApprovalStatus[i]['status'] == 'REJECTED') {
            var obj1 = Object.assign({}, this.allApprovalStatus[i]);
            obj1['action'] = 0;
            obj1['last_approval_level'] = this.lastLevelOfApprovel[this.allApprovalStatus[i]['doc_type']];
            tableObj[this.allApprovalStatus[i]['doc_local_no'] + this.allApprovalStatus[i]['level_of_approval']] = obj1;
          } else {
            var obj1 = Object.assign({}, this.allApprovalStatus[i]);
            if (this.allApprovalStatus[i]['level_of_approval'] == 1) {
              obj1['action'] = 1;
              obj1['last_approval_level'] = this.lastLevelOfApprovel[this.allApprovalStatus[i]['doc_type']];
              tableObj[this.allApprovalStatus[i]['doc_local_no'] + this.allApprovalStatus[i]['level_of_approval']] = obj1;
            }
            else if (this.stepStatus[this.allApprovalStatus[i]['doc_local_no'] + ((this.allApprovalStatus[i]['level_of_approval']) - 1)] == 'PENDING') {
              obj1['action'] = 0;
              obj1['last_approval_level'] = this.lastLevelOfApprovel[this.allApprovalStatus[i]['doc_type']];
              tableObj[this.allApprovalStatus[i]['doc_local_no'] + this.allApprovalStatus[i]['level_of_approval']] = obj1;
            } else {
              obj1['action'] = 1;
              obj1['last_approval_level'] = this.lastLevelOfApprovel[this.allApprovalStatus[i]['doc_type']];
              tableObj[this.allApprovalStatus[i]['doc_local_no'] + this.allApprovalStatus[i]['level_of_approval']] = obj1;
            }
          }
        }
      }



      var keys = Object.keys(tableObj);
      var tt = [];
      for (let i = 0; i < keys.length; i++) {
        tt.push(tableObj[keys[i]])
      }

      for (let j = 0; j < unique.length; j++) {
        var tt1;
        for (let i = 0; i < tt.length; i++) {
          if (tt[i]['doc_local_no'] == unique[j]) {
            if (tt[i]['action'] == 1) {
              tt1 = tt[i];
              this.allTaskArr.push(tt1)

              break;
            } else {
            }

          }
        }
      }
      this.mainService.tasks = this.allTaskArr.length;

    } else {
      swal.fire("Error", "Error while getting Tasks");
    }
  }

  async ViewLeave(obj: any) {
    for (let i = 0; i < this.allLeaves.length; i++) {
      if (this.allLeaves[i]['id'] == obj['doc_local_no']) {
        await this.view(this.allLeaves[i]['document_id'], this.allLeaves[i]['document_name'])
      }
    }
  }
  imgURL: any;
  filename: any
  async view(document_id: any, document_name: any) {
    var obj: any = new Object
    obj['b_acct_id'] = this.b_acct_id
    obj['upload_id'] = document_id
    obj['filename'] = document_name;
    this.filename = document_name;
    this.spinner.show()
    const res = await this.allEmpService.getUploadedFileData(obj);
    if (res) {

      var docname = document_name;
      var ext = docname.split('.');

      if (ext[1] == 'png' || ext[1] == 'jpeg' || ext[1] == 'jpg') {
        const unsafeImageUrl = window.URL.createObjectURL(res);
        this.imgURL = this.sanitizer.bypassSecurityTrustResourceUrl(unsafeImageUrl);
      } else {
        let file = new Blob([res], { type: 'application/pdf' });
        var fileURL = URL.createObjectURL(file);
        window.open(fileURL);
      }
      this.spinner.hide()
    }
  }

  allLeaves = [];
  async allEmployeeLeaveLadger() {
    this.spinner.show();
    var obj: any = new Object();
    obj['b_acct_id'] = this.b_acct_id;
    var resp = await this.payableService.getAllLeaveLedger(obj);
    if (resp['error'] == false) {
      this.spinner.hide();
      this.allLeaves = resp.data;
    } else {
      this.spinner.hide()
      swal.fire("Error", "Error while getting Leaves", 'error');
    }
  }
  async taskStatusChange() {
    // this.clearSeletedData();
    let s: any = this.current_task_data
    this.taskStatus = s;
    this.taskStatus['status'] = 'APPROVED';
    this.taskStatus['level_of_approval'] = s['level_of_approval'];
    this.taskStatus['user_id'] = this.erpUser.user_id;
    this.taskStatus['b_acct_id'] = this.erpUser.b_acct_id;
    this.taskStatus['update_user_id'] = this.erpUser.user_id;
    this.spinner.show();
    var resp = await this.taskService.changeStatus(this.taskStatus);
    if (resp['error'] == false) {
      if (s['last_approval_level'] == s['level_of_approval']) {
        if (s['doc_type'] == 'SAL_BILL' || s['doc_type'] == 'AA_BILL') {
          await this.statusChangeForSALBILL(s, 'APPROVED');
        }
        if (s['doc_type'] == 'SUSPENSION') {
          await this.ChangestatusSalBill(s['doc_local_no'], 'APPROVED');
        }
        if (s['doc_type'] == 'REAPOINT') {
          await this.Changestatusreapointbill(s['doc_local_no'], 'REAPOINTMENT');
        }
        if (s['doc_type'] == 'DEATH') {
          await this.Changedeathstatus(s['doc_local_no'], 'DEATH');
        }
        if (s['doc_type'] == 'TRANSFER') {
          await this.Changedeathstatus(s['doc_local_no'], 'TRANSFERRED');
        }
        if (s['doc_type'] == 'COMPLAINT') {
          await this.Changecomplaintst(s['doc_local_no'], 'REGISTERED');
        }
        if (s['doc_type'] == 'PROBATION') {
          await this.changeprobationst(s['doc_local_no'], 'REGISTERED');
        }
        if (s['doc_type'] == 'ENQUIRY') {
          await this.updatestatusofEnquiry(s['doc_local_no'], 'IN PROCESS');
        }
        if (s['doc_type'] == 'TERMINATE') {
          await this.updatestatusoftermination(s['doc_local_no'], 'UNDER APPROVED');
        }
        if (s['doc_type'] == 'RESIGN') {
          await this.Changestatusresign(s['doc_local_no'], 'APPROVED');
        }
        if (s['doc_type'] == 'DA_ARREAR') {
          await this.statusChangeForDABILL(s, 'APPROVED');
        }
        if (s['doc_type'] == 'ADV_BILL') {
          await this.statusChangeForADVBILL(s, 'APPROVED');
        }
        if (s['doc_type'] == 'EXTRA_ARREAR_BILL') {
          await this.statusChangeForextraarrearBILL(s, 'APPROVED');
        }
        if (s['doc_type'] == 'MED_BILL') {
          await this.statusChangeFormedBILL(s, 'APPROVED');
        }
        if (s['doc_type'] == 'BILL') {
          await this.changeCBStatus(s['doc_local_no'], 'APPROVED');
        }
        if (s['doc_type'] == 'CONTRA') {
          await this.changeContraStatus(s['doc_local_no'], 'APPROVED');
        }
        if (s['doc_type'] == 'BP') {
          await this.changeBPStatus(s['doc_local_no'], 'APPROVED');
        }
        if (s['doc_type'] == 'MJ') {
          await this.changeMJStatus(s['doc_local_no'], 'APPROVED');
        }
        if (s['doc_type'] == 'LEAVE') {
          await this.changeLeaveStatus(s['doc_local_no'], 'APPROVED');
        }
      }
      await this.getAllApprovalStatus();
      this.spinner.hide();
      swal.fire('Success', 'Task APPROVED Successfully', 'success');

    } else {
      this.spinner.hide();
      swal.fire('Error', 'Error while Approving Bill')
    }

  }
  async salbillapprove(status: any, doc_local_no: any) {
    let obj = Object()
    obj['b_acct_id'] = this.b_acct_id
    obj['doc_local_no'] = doc_local_no
    obj["bill_status_code"] = status
    var resp = await this.acrService.billapprove(obj)
    if (resp['error'] == false) {
      swal.fire('success', "successfully approved", 'success')
    } else {

    }
  }


  async updatestatusofEnquiry(bill_id: any, bill_status_code: any) {
    var obj: any = new Object();
    obj['b_acct_id'] = this.b_acct_id;
    obj['update_user_id'] = this.erpUser.user_id;
    obj['enquiry_id'] = bill_id;
    obj['status'] = bill_status_code;
    // obj['bill_status_code'] = "UNDERAPPROVAL";
    // obj['bill_status_code'] = "APPROVED";
    this.spinner.show();
    var resp = await this.payableService.updatestatusofEnquiry(obj);
    if (resp['error'] == false) {

    } else {
      this.spinner.hide();
      Swal.fire('Error', 'Error in Bill Generation', 'error');
    }

  }
  async statusChangeForADVBILL(status: any, doc_local_no: any) {
    let obj = Object()
    obj['b_acct_id'] = this.b_acct_id
    obj['doc_local_no'] = doc_local_no
    var resp = await this.acrService.advbillapprove(obj)
    if (resp['error'] == false) {
      swal.fire('success', "successfully approved", 'success')
    } else {

    }
  }

  async statusChangeForextraarrearBILL(status: any, doc_local_no: any) {
    let obj = Object()
    obj['b_acct_id'] = this.b_acct_id
    obj['doc_local_no'] = doc_local_no
    obj["update_user_id"] = this.erpUser.user_id
    var resp = await this.acrService.extrarrearbillaprove(obj)
    if (resp['error'] == false) {
      swal.fire('success', "successfully approved", 'success')
    } else {

    }
  }

  async statusChangeForMEDBILL(status: any, doc_local_no: any) {
    let obj = Object()
    obj['b_acct_id'] = this.b_acct_id
    obj['doc_local_no'] = doc_local_no
    var resp = await this.acrService.GETMEDbillapprove(obj)
    if (resp['error'] == false) {
      swal.fire('success', "successfully approved", 'success')
    } else {

    }
  }

  async statusChangeFormedBILL(status: any, doc_local_no: any) {
    let obj = Object()
    obj['b_acct_id'] = this.b_acct_id
    obj['doc_local_no'] = doc_local_no
    var resp = await this.acrService.medbillapprove(obj)
    if (resp['error'] == false) {
      swal.fire('success', "successfully approved", 'success')
    } else {

    }
  }



  async taskStatusChange_Reject(s: any) {
    this.taskStatus = s;
    this.taskStatus['status'] = 'REJECTED';
    this.taskStatus['b_acct_id'] = this.erpUser.b_acct_id;
    this.taskStatus['level_of_approval'] = s['level_of_approval'];
    this.taskStatus['user_id'] = this.erpUser.user_id;
    this.taskStatus['update_user_id'] = this.erpUser.user_id;
    this.spinner.show();
    var resp = await this.taskService.changeStatus(this.taskStatus);
    if (resp['error'] == false) {
      if (s['doc_type'] == 'SAL_BILL' || s['doc_type'] == 'AA_BILL') {
        await this.statusChangeForSALBILL(s, 'REJECTED');
      }
      if (s['doc_type'] == 'DA_ARREAR') {
        await this.statusChangeForDABILL(s, 'REJECTED');
      }
      if (s['doc_type'] == 'SUSPENSION') {
        await this.ChangestatusSalBill(s['doc_local_no'], 'REJECTED');
      }
      if (s['doc_type'] == 'REAPOINT') {
        await this.Changestatusreapointbill(s['doc_local_no'], 'REJECTED');
      }
      if (s['doc_type'] == 'DEATH') {
        await this.Changedeathstatus(s['doc_local_no'], 'REJECTED');
      }
      if (s['doc_type'] == 'TRANSFER') {
        await this.Changedeathstatus(s['doc_local_no'], 'REJECTED');
      }
      if (s['doc_type'] == 'COMPLAINT') {
        await this.Changecomplaintst(s['doc_local_no'], 'REJECTED');
      }
      if (s['doc_type'] == 'ENQUIRY') {
        await this.updatestatusofEnquiry(s['doc_local_no'], 'REJECTED');
      }
      if (s['doc_type'] == 'TERMINATE') {
        await this.updatestatusoftermination(s['doc_local_no'], 'REJECTED');
      }
      if (s['doc_type'] == 'PROBATION') {
        await this.changeprobationst(s['doc_local_no'], 'REJECTED');
      }

      if (s['doc_type'] == 'RESIGN') {
        await this.Changestatusresign(s['doc_local_no'], 'REJECTED');
      }

      if (s['doc_type'] == 'BILL') {
        await this.changeCBStatus(s['doc_local_no'], 'REJECTED');
      }
      if (s['doc_type'] == 'CONTRA') {
        await this.changeContraStatus(s['doc_local_no'], 'REJECTED');
      }
      if (s['doc_type'] == 'BP') {
        await this.changeBPStatus(s['doc_local_no'], 'REJECTED');
      }
      if (s['doc_type'] == 'MJ') {
        await this.changeMJStatus(s['doc_local_no'], 'REJECTED');
      }
      if (s['doc_type'] == 'LEAVE') {
        await this.changeLeaveStatus(s['doc_local_no'], 'REJECTED');
      }
      await this.getAllApprovalStatus();
      this.spinner.hide();
      swal.fire('Success', 'Task REJECTED Successfully', 'success');

    } else {
      this.spinner.hide();
      swal.fire('Error', 'Error while rejecting Bill')
    }

  }
  async changeLeaveStatus(id: any, status: any) {
    var dd: any;
    for (let i = 0; i < this.allLeaves.length; i++) {
      if (this.allLeaves[i]['id'] == id) {
        dd = this.allLeaves[i]
      }
    }
    this.spinner.show();
    let obj: any = Object.assign({}, dd);
    obj['b_acct_id'] = this.b_acct_id
    obj['emp_id'] = dd['emp_id']
    obj['leave_status_code'] = status;
    obj['update_user_id'] = this.erpUser.user_id;
    obj['approval_user_id'] = this.erpUser.user_id;
    var resp = await this.payableService.approveLeave(obj);
    if (resp['error'] == false) {
      this.spinner.hide();
    }
    else {
      this.spinner.hide();
    }


  }
  async changeMJStatus(id: any, status: any) {
    this.spinner.show();
    let obj: any = new Object();
    obj['b_acct_id'] = this.b_acct_id
    obj['id'] = id
    obj['status'] = status
    obj['update_user_id'] = this.erpUser.user_id;
    var resp = await this.taskService.updateUnpostedJournalStatus(obj);
    if (resp['error'] == false) {
      this.spinner.hide();
    } else {
      this.spinner.hide();
    }
  }

  async changeBPStatus(id: any, status: any) {
    this.spinner.show();
    let obj: any = new Object();
    obj['b_acct_id'] = this.b_acct_id
    obj['id'] = id
    obj['status'] = status
    obj['update_user_id'] = this.erpUser.user_id;
    var resp = await this.taskService.updateStatus(obj);
    if (resp['error'] == false) {
      this.spinner.hide();
    } else {
      this.spinner.hide();
    }
  }


  async changeContraStatus(id: any, status: any) {
    var obj1: any = new Object();
    obj1['b_acct_id'] = this.b_acct_id;
    obj1['voucher_no'] = id;
    obj1['status'] = status;
    obj1['update_user_id'] = this.erpUser.user_id;

    var resp = await this.taskService.UpdateStatusContra(obj1);
    if (resp['error'] == false) {
      this.spinner.hide();
    } else {
      this.spinner.hide();
    }
  }

  async changeCBStatus(cb_id: any, status: any) {
    var obj1: any = new Object();
    obj1['b_acct_id'] = this.b_acct_id;
    obj1['cb_id'] = [cb_id];
    obj1['status'] = status;
    obj1['update_user_id'] = this.erpUser.user_id;

    var resp = await this.taskService.changeCbStatus(obj1);
    if (resp['error'] == false) {
      this.spinner.hide();
    } else {
      this.spinner.hide();
    }
  }
  PrintObj: any = {}
  async status(element: any) {
    var obj: any = new Object();
    this.PrintObj = {}
    this.PrintObj = JSON.parse(JSON.stringify(element))
    obj["b_acct_id"] = this.b_acct_id;
    obj["doc_local_no"] = this.PrintObj.doc_local_no;
    obj['module_cd'] = this.PrintObj.module_cd
    obj['doc_type'] = this.PrintObj.doc_type
    this.spinner.show();
    var resp = await this.mainService.getWorkflowlog(JSON.stringify(obj));
    if (resp['error'] == false) {
      let obj: any = {};
      obj["id"] = this.PrintObj["doc_local_no"];
      obj["b_acct_id"] = this.b_acct_id;
      obj["work_id"] = this.PrintObj["node_cd"];
      //var ebill = await this.ebillService.getBill(JSON.stringify(obj))

      // if (this.PrintObj.module_cd === "OPERATION" || this.PrintObj.module_cd === "EMB") {
      //   let tender = await this.tenderService.getBoq(JSON.stringify(obj));
      //   this.selectedTender = tender["data"][0];
      // }

      // if (this.PrintObj.module_cd === "OPERATION" || this.PrintObj.doc_type === "VENDOR_BILL") {
      //   var vendorData: any = await this.vbillservice.getVendorDtl(JSON.stringify({ b_acct_id: this.b_acct_id, doc_local_no: element['doc_local_no'] }))
      // }

      if (this.PrintObj.doc_type == "SALARY_BILL" || this.PrintObj.doc_type == "DA_ARREAR_BILL") {
        this.PrintObj['node_cd'] = JSON.parse(this.PrintObj.node_cd)
      }

      await this.ApprovalUserService.getWorkflowloguser(this.erpUser, this.PrintObj)

      for (let i = 0; i < this.ApprovalUserService.workflowuser.length; i++) {
        this.UserObj[this.ApprovalUserService.workflowuser[i]['user_id']] = this.ApprovalUserService.workflowuser[i]['emp_name']

      }

      for (let i = 0; i < resp.data.length; i++) {
        if (resp.data[i]["user_id"] == -1) {
          resp.data[i]["name"] = "Contractor"; //this.partyObj[resp['data'][i]['vendor_id']]
          resp.data[i]["role_cd"] = "Contractor";
          resp.data[i]["user_id"] = resp["data"][i]["vendor_id"];
          resp.data[i]["is_vendor"] = true;
          continue;
        }
        for (let j = 0; j < this.ApprovalUserService.workflowuser.length; j++) {
          if (resp.data[i]['user_id'] == this.ApprovalUserService.workflowuser[j]["user_id"])


            if (resp.data[i]["user_id"] == this.ApprovalUserService.workflowuser[j]["user_id"] && resp.data[i]["role_cd"] == this.ApprovalUserService.workflowuser[j]["role_cd"]) {
              resp.data[i]["name"] = this.ApprovalUserService.workflowuser[j]["emp_name"];
              resp.data[i]["role_cd"] = this.ApprovalUserService.workflowuser[j]["role_cd"];
            }
        }
        if (resp.data[i]["name"] == undefined) {
          resp.data[i]["name"] = "";
        }
      }

      // if (this.PrintObj.module_cd === "OPERATION" && !vendorData['error']) {
      //   this.statusArr.splice(0, 0, { role_cd: 'VENDOR', user_name: vendorData['data'].vendor_name, status: 'BILL REQUEST', create_timestamp: vendorData['data'].valid_from })
      // }

      this.statusArr = resp['data'];

      // this.statusArr.map((x:any) => {
      //   if(JSON.parse(x['remark'])['body']){

      //     x['remark'] = JSON.parse(x['remark'])['body']
      //   }
      // })

      this.statusArr.map((x: any) => {

        if (x['remark'] == null || x['remark'] == "" || x['remark'] == undefined) {
          x['remark'] = 'No Remark'
          x['language'] = 'English'
        }

        if (x && 'remark' in x) {
          try {
            const parsedRemark = JSON.parse(x['remark']);
            if (typeof parsedRemark === 'object' && 'body' in parsedRemark) {
              x['remark'] = parsedRemark['body'];
            }
          } catch (e) {


          }
        }
      })


      $('#myModal').modal('show');

      this.spinner.hide()
    } else {
      this.spinner.hide();
      swal.fire("Error", "Error while getting status");
    }
  }

  // previous_log_status = []
  // previous_log_message = ""

  // currentObject = { doc_type: null, }


  // async getPreviousWorkflowLog(element:any) {
  //   let obj:any = {}
  //   obj['is_account_module'] = 0;
  //   obj['event_id'] = element.doc_local_no
  //   obj['ar_actvty_tcd'] = element.doc_type
  //   obj['module_cd'] = element.module_cd;
  //   obj['ld_prj_cd'] = element.node_cd
  //   this.previous_log_status = []
  //   this.previous_log_status = await this.processDocumentPrintService.viewStatus(obj)
  //   this.previous_log_status.map((x:any) => {        
  //     if (x && 'remark' in x) {
  //       try {
  //         const parsedRemark = JSON.parse(x['remark']);
  //         if (typeof parsedRemark === 'object' && 'body' in parsedRemark) {
  //           x['remark'] = parsedRemark['body'];
  //         }
  //       } catch (e) {
  //         console.log('error')

  //       }
  //     }      
  //   })
  //   // this.previous_log_status.map((x:any) => {
  //   //   if(JSON.parse(x['remark'])['body']){
  //   //     x['remark'] = JSON.parse(x['remark'])['body']

  //   //   }
  //   // })
  // }
  // notesheet_data = {}
  // async getNotesheetData(data) {
  //   this.notesheet_data = {}
  //   var obj = Object()
  //   obj['b_acct_id'] = this.erpUser.b_acct_id
  //   obj['bill_id'] = data.doc_local_no
  //   obj['is_account_module'] = data['module_cd'] === "ACCOUNT" ? 1 : 0;
  //   var resp = await this.vbillservice.getNotesheet(JSON.stringify(obj))
  //   if (resp['error'] == false) {
  //     console.log(resp['data'])
  //     this.notesheet_data = resp['data'][0]['notesheet_desc'];
  //     // this.notesheet_data = JSON.parse(resp['data'][0]['notesheet_desc'])['body'];
  //     if (resp['data'][0]['language'] === 'Hindi') {
  //       this.hindi_text_flag = true
  //     } else {
  //       this.hindi_text_flag = false
  //     }

  //   } else {
  //     swal.fire("Error", resp['data'], 'error');
  //   }
  // }



  ////****************************************************************************************** */
  back() {
    // this.router.navigate(['/index'])
    // this.router.navigate(['/icms/icms-index'])
    this.hr_note_sheet = null;
    window.history.go(-1)
  }
  async getAllEmployees() {
    var obj: any = new Object();
    obj['b_acct_id'] = this.b_acct_id;
    var resp = await this.taskService.getEmployeeMasterData(obj);
    if (resp['error'] == false) {
      this.allEmplyees = resp.data;
      for (var i = 0; i < this.allEmplyees.length; i++) {
        this.salaryObj.emp_info[this.allEmplyees[i].emp_id] = this.allEmplyees[i];
      }
    } else {
      Swal.fire('Error', "Error while getting Employee Info")
    }
  }

  async getAllActiveEmployees() {
    var obj: any = new Object();
    obj['b_acct_id'] = this.b_acct_id;
    var resp = await this.taskService.getArrayAllCurrentEstablishementInfo(JSON.stringify(obj));
    if (resp['error'] == false) {
      this.allCurrentArrangements = resp['data'];
      for (var i = 0; i < this.allCurrentArrangements.length; i++) {
        this.salaryObj.employement_info[this.allCurrentArrangements[i].emp_id] = this.allCurrentArrangements[i];

      }

    } else {
      Swal.fire('Error', "Error while getting Employement Info")

    }
  }
  getNumberFormat(num: any) {
    return num.toString().padStart(3, "0")
  }




  async getAllBill(ob: any, type: any) {
    this.spinner.show()
    await this.getAllEmployees();
    await this.getAllActiveEmployees();
    this.currentBillObj = { header: {}, allEmployees: [], data: {}, sums: {} };

    var obj: any = new Object();
    obj['b_acct_id'] = this.b_acct_id;
    obj['bill_id'] = ob['doc_local_no'];
    var resp = await this.taskService.getAllBill(JSON.stringify(obj));
    if (resp['error'] == false) {
      var billObj: any = {};
      var header = "";
      var dt = resp['data'];
      if (dt.length > 0) {
        header = dt[0];
      }
      var grand: any = undefined;
      var month: any = "";
      var fin_year: any = "";
      for (var i = 0; i < dt.length; i++) {
        //header = dt[0];
        if (billObj[dt[i]['section_code']] == undefined) {
          month = dt[i]['month'];
          fin_year = dt[i]['fin_year'];
          billObj[dt[i]['section_code']] = {};
          billObj[dt[i]['section_code']]['data'] = {};//{'BASIC':0.00,'DA':0.00,'DEP':0.00,'HRA':0.00,'MA':0.00,'VA':0.00,'WA':0.00,'miscpay':[],'LIC1':0.00,LIC2:0.00,LIC3:0.00,LIC4:0.00,LIC5:0.00,LIC6:0.00,LIC7:0.00,PF:0.00,GIS:0.00,IT:0.00,HRR:0.00,VD:0.00,VADV:0.00,BLDADV1:0.00,BLDADV2:0.00,BLDADV3:0.00,PFADV:0.00,PFADV1:0.00,PFADV2:0.00,BADV:0.00,EWF:0.00,miscded:[]};
          billObj[dt[i]['section_code']]['total'] = { 'BASIC': 0.00, 'DA': 0.00, 'DEP': 0.00, 'HRA': 0.00, 'MA': 0.00, 'VA': 0.00, 'WA': 0.00, 'miscpay': [], 'LIC1': 0.00, LIC2: 0.00, LIC3: 0.00, LIC4: 0.00, LIC5: 0.00, LIC6: 0.00, LIC7: 0.00, PF: 0.00, NPS: 0.00, GIS: 0.00, IT: 0.00, HRR: 0.00, VD: 0.00, VADV: 0.00, BLDADV1: 0.00, BLDADV2: 0.00, BLDADV3: 0.00, PFADV: 0.00, PFADV1: 0.00, PFADV2: 0.00, BADV: 0.00, EWF: 0.00, miscded: [], total: 0.00, net: 0.00 };
          if (grand == undefined) {
            grand = { 'BASIC': 0.00, 'DA': 0.00, 'DEP': 0.00, 'HRA': 0.00, 'MA': 0.00, 'VA': 0.00, 'WA': 0.00, 'miscpay': [], 'LIC1': 0.00, LIC2: 0.00, LIC3: 0.00, LIC4: 0.00, LIC5: 0.00, LIC6: 0.00, LIC7: 0.00, PF: 0.00, GIS: 0.00, NPS: 0.00, IT: 0.00, HRR: 0.00, VD: 0.00, VADV: 0.00, BLDADV1: 0.00, BLDADV2: 0.00, BLDADV3: 0.00, PFADV: 0.00, PFADV1: 0.00, PFADV2: 0.00, BADV: 0.00, EWF: 0.00, miscded: [], total: 0.00, net: 0.00 };
          }
        }
        if (billObj[dt[i]['section_code']]['data'][dt[i]['emp_id']] == undefined) {
          billObj[dt[i]['section_code']]['data'][dt[i]['emp_id']] = { emp_id: '', emp_name: '', designation_code: '', grade_pay_code: '', pay_band: '', sal_acc: '', pf: '', pf_ifsc: '', 'BASIC': 0.00, 'DA': 0.00, 'DEP': 0.00, 'HRA': 0.00, 'MA': 0.00, 'VA': 0.00, 'WA': 0.00, 'miscpay': [], 'LIC1': 0.00, LIC2: 0.00, LIC3: 0.00, LIC4: 0.00, LIC5: 0.00, LIC6: 0.00, LIC7: 0.00, PF: 0.00, NPS: 0.00, GIS: 0.00, IT: 0.00, HRR: 0.00, VD: 0.00, VADV: 0.00, BLDADV1: 0.00, BLDADV2: 0.00, BLDADV3: 0.00, PFADV: 0.00, PFADV1: 0.00, PFADV2: 0.00, BADV: 0.00, EWF: 0.00, miscded: [], total: 0.00, net: 0.00 };
          billObj[dt[i]['section_code']]['data'][dt[i]['emp_id']]['emp_id'] = "VDA" + this.getNumberFormat(dt[i]['emp_id']);
          billObj[dt[i]['section_code']]['data'][dt[i]['emp_id']]['emp_name'] = this.salaryObj.emp_info[dt[i].emp_id]['emp_name'];
          billObj[dt[i]['section_code']]['data'][dt[i]['emp_id']]['designation_code'] = this.salaryObj.employement_info[dt[i].emp_id]['designation_code'];;
          billObj[dt[i]['section_code']]['data'][dt[i]['emp_id']]['grade_pay_code'] = "GP " + this.salaryObj.employement_info[dt[i].emp_id]['grade_pay_code'];
          billObj[dt[i]['section_code']]['data'][dt[i]['emp_id']]['pay_band'] = 'PB ' + '(' + this.salaryObj.employement_info[dt[i].emp_id]['pay_scale_code'] + ')';
          billObj[dt[i]['section_code']]['data'][dt[i]['emp_id']]['sal_acc'] = this.salaryObj.emp_info[dt[i].emp_id]['acct_no'];
          billObj[dt[i]['section_code']]['data'][dt[i]['emp_id']]['pf'] = this.salaryObj.emp_info[dt[i].emp_id]['pf_acct_no'];
          billObj[dt[i]['section_code']]['data'][dt[i]['emp_id']]['pf_ifsc'] = this.salaryObj.emp_info[dt[i].emp_id]['pf_ifsc_code'];
        }
        if (dt[i]['pay_code'] == 'PAY') {
          billObj[dt[i]['section_code']]['data'][dt[i]['emp_id']]['total'] += dt[i]['pay_component_amt'];
          billObj[dt[i]['section_code']]['data'][dt[i]['emp_id']]['net'] += dt[i]['pay_component_amt'];
          billObj[dt[i]['section_code']]['total']['total'] += dt[i]['pay_component_amt'];
          billObj[dt[i]['section_code']]['total']['net'] += dt[i]['pay_component_amt'];
          grand['total'] += dt[i]['pay_component_amt'];
          grand['net'] += dt[i]['pay_component_amt'];

          if (billObj[dt[i]['section_code']]['data'][dt[i]['emp_id']][dt[i]['pay_component_code']] != undefined) {
            billObj[dt[i]['section_code']]['total'][dt[i]['pay_component_code']] += dt[i]['pay_component_amt'];
            grand[dt[i]['pay_component_code']] += dt[i]['pay_component_amt'];

            billObj[dt[i]['section_code']]['data'][dt[i]['emp_id']][dt[i]['pay_component_code']] += dt[i]['pay_component_amt'];
          } else {
            billObj[dt[i]['section_code']]['total']['miscpay'].push({ code: dt[i]['pay_component_code'], amount: dt[i]['pay_component_amt'] });
            grand['miscpay'].push({ code: dt[i]['pay_component_code'], amount: dt[i]['pay_component_amt'] });

            billObj[dt[i]['section_code']]['data'][dt[i]['emp_id']]['miscpay'].push({ code: dt[i]['pay_component_code'], amount: dt[i]['pay_component_amt'] });
          }

        } else {
          billObj[dt[i]['section_code']]['total']['net'] -= dt[i]['pay_component_amt'];
          grand['net'] -= dt[i]['pay_component_amt'];

          billObj[dt[i]['section_code']]['data'][dt[i]['emp_id']]['net'] -= dt[i]['pay_component_amt'];
          if (billObj[dt[i]['section_code']]['data'][dt[i]['emp_id']][dt[i]['pay_component_code']] != undefined) {
            billObj[dt[i]['section_code']]['total'][dt[i]['pay_component_code']] += dt[i]['pay_component_amt'];
            grand[dt[i]['pay_component_code']] += dt[i]['pay_component_amt'];

            billObj[dt[i]['section_code']]['data'][dt[i]['emp_id']][dt[i]['pay_component_code']] += dt[i]['pay_component_amt'];
          } else {
            billObj[dt[i]['section_code']]['total']['miscded'].push({ code: dt[i]['pay_component_code'], amount: dt[i]['pay_component_amt'] });
            grand['miscded'].push({ code: dt[i]['pay_component_code'], amount: dt[i]['pay_component_amt'] });

            billObj[dt[i]['section_code']]['data'][dt[i]['emp_id']]['miscded'].push({ code: dt[i]['pay_component_code'], amount: dt[i]['pay_component_amt'] });
          }

        }
      }
      if (type == 'bill') {
        this.print(billObj, header, grand, month, fin_year);

      }
      else {
        this.print1(billObj, header, grand, month, fin_year);
      }
      this.spinner.hide()
    } else {
      this.spinner.hide();
      swal.fire("Error", "Error while printing pay bill")
    }
  }
  async statusChangeForSALBILL(element: any, bill_status_code: any) {
    var obj: any = new Object();
    obj['b_acct_id'] = this.b_acct_id;
    obj['update_user_id'] = this.erpUser.user_id;
    obj['bill_id'] = element.doc_local_no;
    obj['bill_status_code'] = bill_status_code;
    this.spinner.show();
    var resp = await this.taskService.changeStatusOfBill(obj);
    if (resp['error'] == false) {
      this.spinner.hide();
    } else {
      this.spinner.hide();
      swal.fire('Error', 'Error in Bill Generation');
    }

  }

  async statusChangeForDABILL(arrear_id: any, status: any) {
    var obj: any = new Object();
    obj['b_acct_id'] = this.b_acct_id;
    obj['update_user_id'] = this.erpUser.user_id;
    obj['arrear_id'] = arrear_id;
    obj['bill_status_code'] = status;
    // obj['arrear_id'] = this.billIdObj['arrear_id'];
    // obj['bill_status_code'] = 'APPROVED';
    // obj['bill_status_code'] = "UNDERAPPROVAL";
    // obj['bill_status_code'] = "APPROVED";
    this.spinner.show();
    var resp = await this.payableService1.changeStatusOfDAArrearBill(obj);
    if (resp['error'] == false) {
      //await this.sendToApproval(resp['data']);
      // setTimeout(async () => {

      //   //await this.insertIntoAccount(1);
      //   this.spinner.hide();
      //   Swal.fire('Success', 'Bill APPROVED Successfully', 'success');
      // }, 1000);

    } else {
      this.spinner.hide();
      Swal.fire('Error', 'Error in Bill Generation', 'error');
    }

  }

  async sendBillToAccount() {
    var billObj: any = new Object();
    billObj["b_acct_id"] = this.b_acct_id;
    billObj['data'] = [];
    var amt = 0;
    var cb_description = '';
    var cb_date = "";
    for (var i = 0; i < this.allBillData.length; i++) {
      amt += this.allBillData[i].pay_component_amt;
      cb_date = this.allBillData[i]['bill_date'];
      cb_description = this.allBillData[i]['bill_desc'];
      var ob: any = new Object();
      ob['account_amount'] = this.allBillData[i].pay_component_amt
      ob['account_code'] = this.allBillData[i].pay_component_code
      ob['party_id'] = "HR" + this.allBillData[i]['emp_id'];
      ob['cb_description'] = cb_description;
      ob['cb_date'] = cb_date;
      ob['source_code'] = "HR";
      billObj['source_local_no'] = "HR" + this.allBillData[i]['bill_id'];

      ob['source_local_no'] = "HR" + this.allBillData[i]['bill_id'];

      billObj['data'].push(JSON.stringify(ob));
    }

    billObj["cb_description"] = cb_description;
    billObj['cb_amount'] = amt;
    billObj['cb_date'] = cb_date;
    billObj['cb_status'] = "PENDING"
    billObj['source_code'] = "HR"

    billObj['create_user_id'] = this.erpUser.user_id;
    var resp = await this.taskService.createContingentBill(billObj);
    if (resp['error'] == false) {

    } else {
      this.spinner.hide();
      swal.fire('Error', 'Error while sending the bill to accounts');
    }
  }

  arr2: any = []



  print(billObj: any, header: any, grand: any, month: any, fin_year: any) {
    var txt = this.mainService.accInfo['account_name'] + "(" + this.mainService.accInfo['account_short_name'] + ")" + "   " + header['bill_desc'] + "   Date: " + header['accrual_date'];
    var dd: any = {
      pageSize: 'A2',
      header: function (currentPage: any, pageCount: any) {
        var obj = { text: txt + "     Page No. - " + currentPage, alignment: 'center', margin: [72, 40] };
        return obj;
      },

      // by default we use portrait, you can change it to landscape if you wish
      pageOrientation: 'landscape',

      // [left, top, right, bottom] or [horizontal, vertical] or just a number for equal margins
      pageMargins: [40, 60, 40, 60],
      //pageMargins: [ 40, 20, 20, 20 ],
      content: [

      ]
    };
    var sections = Object.keys(billObj);
    var count = 0;
    for (var i = 0; i < sections.length; i++) {
      var data = billObj[sections[i]];

      var sectionText: any = { text: 'Section : ' + sections[i], fontSize: 8 };
      if (i != 0) {
        sectionText['pageBreak'] = 'before'
      }
      dd.content.push(sectionText);
      var tbl = {

        layout: 'lightHorizontalLines',
        fontSize: 10,
        table: {

          headerRows: 1,
          widths: ['auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto'],

          body: [
            ['Emp\nDetail', 'Basic\nPay', 'Dep.\nAllow', 'DA/Relief', 'Med\nAllow', 'Veh\nAllow', 'HRA', 'WA', 'Misc\nAllow', 'Total', 'LIC', 'PF\nDed', 'NPS', 'Group\nIns.', 'IT', 'House\nRent', 'Veh\nDed', 'Veh\nAdv.', 'Bld\nAdv.', 'PF\nAdv.', 'Bank\nAdv.', 'EWF', 'Misc\nDed', 'Net.\nSal.']



          ]
        }
      };
      dd.content.push(tbl);
      var emps = Object.keys(data['data']);
      count = count + emps.length;
      for (var j = 0; j < emps.length; j++) {
        var obj = data['data'][emps[j]];
        var arr = [];
        var str = obj['emp_id'] + "\n" + obj['emp_name'] + "\n" + obj['designation_code'] + "\n" + obj['grade_pay_code'] + "\n" + obj['pay_band'] + "\n" + "SAL A/C - " + obj['sal_acc'];
        if (obj['pf'] != undefined && obj['pf'] != null && obj['pf'] != 0) {
          str += "\n" + "PF A/C - " + obj['pf']
        }
        if (obj['pf_ifsc'] != undefined && obj['pf_ifsc'] != null && obj['pf_ifsc'] != 0) {
          str += "\n" + "PF Ifsc - " + obj['pf_ifsc']
        }
        arr.push(str);
        arr.push(obj['BASIC']);
        arr.push(obj['DEP']);
        arr.push(obj['DA']);
        arr.push(obj['MA']);
        arr.push(obj['VA']);
        arr.push(obj['HRA']);
        arr.push(obj['WA']);
        var miscpay = obj['miscpay'];
        var str1 = "";
        for (var k = 0; k < miscpay.length; k++) {
          if (k == 0) {
            str1 += miscpay[k]['code'] + " - " + miscpay[k]['amount'];
          } else {
            str1 += "\n" + miscpay[k]['code'] + " - " + miscpay[k]['amount'];
          }

        }
        if (str1 != "") {
          arr.push(str1);
        }
        else {
          arr.push(0.00);
        }
        arr.push(obj['total']);
        var licstr = obj['LIC1'] + "\n" + obj['LIC2'] + "\n" + obj['LIC3'] + "\n" + obj['LIC4'] + "\n" + obj['LIC5'] + "\n" + obj['LIC6'] + "\n" + obj['LIC7'];

        arr.push(licstr);
        arr.push(obj['PF']);
        arr.push(obj['NPS']);
        arr.push(obj['GIS']);
        arr.push(obj['IT']);
        arr.push(obj['HRR']);
        arr.push(obj['VD']);
        arr.push(obj['VADV']);
        var bldstr = obj['BLDADV1'] + "\n" + obj['BLDADV2'] + "\n" + obj['BLDADV3']
        arr.push(bldstr);
        var pfstr = obj['PFADV'] + "\n" + obj['PFADV1'] + "\n" + obj['PFADV2']
        arr.push(pfstr);
        arr.push(obj['BADV']);
        arr.push(obj['EWF']);
        var miscded = obj['miscded'];
        var str2 = "";
        for (var k = 0; k < miscded.length; k++) {
          if (k == 0) {
            str2 += miscded[k]['code'] + " - " + miscded[k]['amount'];
          } else {
            str2 += "\n" + miscded[k]['code'] + " - " + miscded[k]['amount'];
          }

        }
        if (str2 != "") {
          arr.push({ text: str2, fontSize: 8 });
        }
        else {
          arr.push(0.00);
        }

        arr.push(obj['net']);

        dd.content[dd.content.length - 1].table.body.push(arr);
      }
      var obj = data['total'];
      var arr = [];
      var str = "Section : " + sections[i] + "\n";
      str += "Total Employees : " + emps.length;

      arr.push(str);
      arr.push(obj['BASIC']);
      arr.push(obj['DEP']);
      arr.push(obj['DA']);
      arr.push(obj['MA']);
      arr.push(obj['VA']);
      arr.push(obj['HRA']);
      arr.push(obj['WA']);
      var miscpay: any = obj['miscpay'];
      var miscpayObj: any = {};
      for (var k = 0; k < miscpay.length; k++) {
        if (miscpayObj[miscpay[k]['code']] == undefined) {
          miscpayObj[miscpay[k]['code']] = 0;
        }
        miscpayObj[miscpay[k]['code']] += miscpay[k]['amount'];
      }
      var str2 = "";
      var keys = Object.keys(miscpayObj);
      for (var k = 0; k < keys.length; k++) {
        if (k == 0) {
          str2 += keys[k] + " - " + miscpayObj[keys[k]];
        } else {
          str2 += "\n" + keys[k] + " - " + miscpayObj[keys[k]];;
        }

      }
      if (str2 != "") {
        arr.push({ text: str2, fontSize: 8 });
      }
      else {
        arr.push(0.00);
      }
      arr.push(obj['total']);
      var licstr = obj['LIC1'] + "\n" + obj['LIC2'] + "\n" + obj['LIC3'] + "\n" + obj['LIC4'] + "\n" + obj['LIC5'] + "\n" + obj['LIC6'] + "\n" + obj['LIC7'];

      arr.push(licstr);
      arr.push(obj['PF']);
      arr.push(obj['NPS']);
      arr.push(obj['GIS']);
      arr.push(obj['IT']);
      arr.push(obj['HRR']);
      arr.push(obj['VD']);
      arr.push(obj['VADV']);
      var bldstr = obj['BLDADV1'] + "\n" + obj['BLDADV2'] + "\n" + obj['BLDADV3']
      arr.push(bldstr);
      var pfstr = obj['PFADV'] + "\n" + obj['PFADV1'] + "\n" + obj['PFADV2']
      arr.push(pfstr);
      arr.push(obj['BADV']);
      arr.push(obj['EWF']);
      var miscded: any = obj['miscded'];
      var miscdedObj: any = {};
      for (var k = 0; k < miscded.length; k++) {
        if (miscdedObj[miscded[k]['code']] == undefined) {
          miscdedObj[miscded[k]['code']] = 0;
        }
        miscdedObj[miscded[k]['code']] += miscded[k]['amount'];
      }
      var str2 = "";
      var keys = Object.keys(miscdedObj);
      for (var k = 0; k < keys.length; k++) {
        if (k == 0) {
          str2 += keys[k] + " - " + miscdedObj[keys[k]];
        } else {
          str2 += "\n" + keys[k] + " - " + miscdedObj[keys[k]];;
        }

      }
      if (str2 != "") {
        arr.push({ text: str2, fontSize: 8 });
      }
      else {
        arr.push(0.00);
      }

      arr.push(obj['net']);

      dd.content[dd.content.length - 1].table.body.push(arr);

    }
    var totalText = { text: 'Grand Total' + "\nTotal Employees : " + count, fontSize: 10, bold: true };

    var obj = grand;
    var arr = []
    arr.push(totalText);
    arr.push(obj['BASIC']);
    arr.push(obj['DEP']);
    arr.push(obj['DA']);
    arr.push(obj['MA']);
    arr.push(obj['VA']);
    arr.push(obj['HRA']);
    arr.push(obj['WA']);
    var miscpay: any = obj['miscpay'];
    var miscpayObj: any = {};
    for (var k = 0; k < miscpay.length; k++) {
      if (miscpayObj[miscpay[k]['code']] == undefined) {
        miscpayObj[miscpay[k]['code']] = 0;
      }
      miscpayObj[miscpay[k]['code']] += miscpay[k]['amount'];
    }
    var str2 = "";
    var keys = Object.keys(miscpayObj);
    for (var k = 0; k < keys.length; k++) {
      if (k == 0) {
        str2 += keys[k] + " - " + miscpayObj[keys[k]];
      } else {
        str2 += "\n" + keys[k] + " - " + miscpayObj[keys[k]];;
      }

    }
    if (str2 != "") {
      arr.push({ text: str2, fontSize: 8 });
    }
    else {
      arr.push(0.00);
    }
    arr.push({ text: obj['total'], bold: true });
    var amt = obj['LIC1'] + obj['LIC2'] + obj['LIC3'] + obj['LIC4'] + obj['LIC5'] + obj['LIC6'] + obj['LIC7']
    //var licstr=obj['LIC1']+"\n"+obj['LIC2']+"\n"+obj['LIC3']+"\n"+obj['LIC4']+"\n"+obj['LIC5']+"\n"+obj['LIC6']+"\n"+obj['LIC7'];
    //var licstr={ text: 'Section : '+sections[i]+"\nTotal Employees : "+emps.length, fontSize: 8};
    arr.push(amt);
    arr.push(obj['PF']);
    arr.push(obj['NPS']);
    arr.push(obj['GIS']);
    arr.push(obj['IT']);
    arr.push(obj['HRR']);
    arr.push(obj['VD']);
    arr.push(obj['VADV']);
    amt = obj['BLDADV1'] + obj['BLDADV2'] + obj['BLDADV3'];
    //var bldstr=obj['BLDADV1']+"\n"+obj['BLDADV2']+"\n"+obj['BLDADV3']
    arr.push(amt);
    amt = obj['PFADV'] + obj['PFADV1'] + obj['PFADV2'];
    //var pfstr=obj['PFADV']+"\n"+obj['PFADV1']+"\n"+obj['PFADV2']
    arr.push(amt);
    arr.push(obj['BADV']);
    arr.push(obj['EWF']);
    var miscded: any = obj['miscded'];
    var miscdedObj: any = {};
    for (var k = 0; k < miscded.length; k++) {
      if (miscdedObj[miscded[k]['code']] == undefined) {
        miscdedObj[miscded[k]['code']] = 0;
      }
      miscdedObj[miscded[k]['code']] += miscded[k]['amount'];
    }
    var str2 = "";
    var keys = Object.keys(miscdedObj);
    for (var k = 0; k < keys.length; k++) {
      if (k == 0) {
        str2 += keys[k] + " - " + miscdedObj[keys[k]];
      } else {
        str2 += "\n" + keys[k] + " - " + miscdedObj[keys[k]];;
      }

    }
    if (str2 != "") {
      arr.push({ text: str2, fontSize: 8 });
    }
    else {
      arr.push(0.00);
    }

    arr.push({ text: obj['net'], bold: true });

    dd.content[dd.content.length - 1].table.body.push(arr);
    dd.content.push("\n\n");
    var sign = {
      columns: [
        {
          // auto-sized columns have their widths based on their content
          width: 'auto',
          text: 'PREPARED BY:',
          bold: true,
          fontSize: 10
        },
        {
          // auto-sized columns have their widths based on their content
          width: 'auto',
          text: 'CHECKED BY:',
          bold: true,
          fontSize: 10
        },
        {
          // auto-sized columns have their widths based on their content
          width: 'auto',
          text: 'SIGNED BY:',
          bold: true,
          fontSize: 10
        },


      ]
    }
    dd.content.push("\n\n\n");
    dd.content.push("PREPARED BY:                               CHECKED BY:                           SIGNED BY:                         ");
    dd.content.push("\n\n");
    dd.content.push("CERTIFIED:")
    dd.content.push("\n\n");
    dd.content.push({ text: "1. That I have satisfied myself that all the salaries included in the bills drawn in the month of " + this.monthObj[month] + "/" + fin_year + " [the last preceding month] with the exception of those detailed below of which total has been refunded by deduction from the bill has been distributed to the proper persons and their receipts have been taken in acquittance rolls field in my office with reciept-stamp dully cancelled for every payment in access of Rs. 20 and that all leaves and promotions etc have been in the service book of the official concerned." })
    dd.content.push("\n")
    dd.content.push({ text: "2. That all persons for whom pay has been drawn in this bill have actually been entertained during the month." })
    dd.content.push("\n");

    dd.content.push({ text: "3. That all the persons for whom house-rent allowance has been shown in this bill actually occupied a rented house for which they paid rent as shown in this bill and are entitled to the allowance under the standing instructions." })
    dd.content.push("\n");

    dd.content.push({ text: "4. That all the persons in respect of whom conveyance allowance has been drawn in the bill have satisfied me that they have actually maintained the conveyance in a workable condition and have been using them." })
    dd.content.push("\n");

    dd.content.push({ text: "5. That the bill has been checked with the sanctioned in the scale register." })
    dd.content.push("\n");

    dd.content.push({ text: "Date :                                                    Signature Of Drawing Officer:" })
    dd.content.push("\n");

    dd.content.push({ text: "Pay Rs. ....................................." })




    pdfMake.createPdf(dd).download();
  }

  print1(billObj: any, header: any, grand: any, month: any, fin_year: any) {
    if (month == 1 || month == 2 || month == 3) {
      fin_year = fin_year + 1;
    }

    //var txt = "VARANASASI DEVELOPMENT AUTHORITY(VDA)   Officers/THIRD/FOURTH Category EMPLOYEES STATEMENT FOR THE MONTH OF June,2020   PIRNT DATE: 2020-10-10"
    var txt = this.mainService.accInfo['account_name'] + "(" + this.mainService.accInfo['account_short_name'] + ")" + "   " + header['bill_desc'] + "   Date: " + header['accrual_date'];
    var dd: any = {
      pageSize: 'A3',
      header: function (currentPage: any, pageCount: any) {
        var obj = { text: txt + "     Page No. - " + currentPage, alignment: 'center', margin: [72, 40] };
        return obj;
      },

      //footer: function(currentPage, pageCount) { return currentPage.toString() + ' of ' + pageCount; },

      // by default we use portrait, you can change it to landscape if you wish
      pageOrientation: 'landscape',

      // [left, top, right, bottom] or [horizontal, vertical] or just a number for equal margins
      pageMargins: [40, 60, 40, 60],
      //pageMargins: [ 40, 20, 20, 20 ],
      content: [

      ]
    };
    var sections = Object.keys(billObj);
    var count = 0;
    var tbl = {

      layout: 'lightHorizontalLines',
      fontSize: 10,
      table: {

        headerRows: 1,
        widths: ['auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto'],

        body: [
          ['Section\nDetail', 'Basic\nPay', 'Dep.\nAllow', 'DA/Relief', 'Med\nAllow', 'Veh\nAllow', 'HRA', 'WA', 'Misc\nAllow', 'Total', 'LIC', 'PF\nDed', 'NPS', 'Group\nIns.', 'IT', 'House\n Rent', 'Veh\nDed', 'Veh\nAdv.', 'Bld\nAdv.', 'PF\nAdv.', 'Bank\nAdv.', 'EWF', 'Misc\nDed', 'Net.\nSal.']
        ]
      }
    };
    dd.content.push(tbl);
    for (var i = 0; i < sections.length; i++) {
      var data = billObj[sections[i]];
      var emps = Object.keys(data['data']);
      count += emps.length;
      var obj = data['total'];
      var arr = [];
      var sectionText = { text: 'Section : ' + sections[i] + "\nTotal Employees : " + emps.length, fontSize: 10, bold: true };



      arr.push(sectionText);
      arr.push(obj['BASIC']);
      arr.push(obj['DEP']);
      arr.push(obj['DA']);
      arr.push(obj['MA']);
      arr.push(obj['VA']);
      arr.push(obj['HRA']);
      arr.push(obj['WA']);
      var miscpay: any = obj['miscpay'];
      var miscpayObj: any = {};
      for (var k = 0; k < miscpay.length; k++) {
        if (miscpayObj[miscpay[k]['code']] == undefined) {
          miscpayObj[miscpay[k]['code']] = 0;
        }
        miscpayObj[miscpay[k]['code']] += miscpay[k]['amount'];
      }
      var str2 = "";
      var keys = Object.keys(miscpayObj);
      for (var k = 0; k < keys.length; k++) {
        if (k == 0) {
          str2 += keys[k] + " - " + miscpayObj[keys[k]];
        } else {
          str2 += "\n" + keys[k] + " - " + miscpayObj[keys[k]];;
        }

      }
      if (str2 != "") {
        arr.push({ text: str2, fontSize: 8 });
      }
      else {
        arr.push(0.00);
      }
      arr.push({ text: obj['total'], bold: true });
      var amt = obj['LIC1'] + obj['LIC2'] + obj['LIC3'] + obj['LIC4'] + obj['LIC5'] + obj['LIC6'] + obj['LIC7']
      //var licstr=obj['LIC1']+"\n"+obj['LIC2']+"\n"+obj['LIC3']+"\n"+obj['LIC4']+"\n"+obj['LIC5']+"\n"+obj['LIC6']+"\n"+obj['LIC7'];
      //var licstr={ text: 'Section : '+sections[i]+"\nTotal Employees : "+emps.length, fontSize: 8};
      arr.push(amt);
      arr.push(obj['PF']);
      arr.push(obj['NPS']);
      arr.push(obj['GIS']);
      arr.push(obj['IT']);
      arr.push(obj['HRR']);
      arr.push(obj['VD']);
      arr.push(obj['VADV']);
      amt = obj['BLDADV1'] + obj['BLDADV2'] + obj['BLDADV3'];
      //var bldstr=obj['BLDADV1']+"\n"+obj['BLDADV2']+"\n"+obj['BLDADV3']
      arr.push(amt);
      amt = obj['PFADV'] + obj['PFADV1'] + obj['PFADV2'];
      //var pfstr=obj['PFADV']+"\n"+obj['PFADV1']+"\n"+obj['PFADV2']
      arr.push(amt);
      arr.push(obj['BADV']);
      arr.push(obj['EWF']);
      var miscded: any = obj['miscded'];
      var miscdedObj: any = {};
      for (var k = 0; k < miscded.length; k++) {
        if (miscdedObj[miscded[k]['code']] == undefined) {
          miscdedObj[miscded[k]['code']] = 0;
        }
        miscdedObj[miscded[k]['code']] += miscded[k]['amount'];
      }
      var str2 = "";
      var keys = Object.keys(miscdedObj);
      for (var k = 0; k < keys.length; k++) {
        if (k == 0) {
          str2 += keys[k] + " - " + miscdedObj[keys[k]];
        } else {
          str2 += "\n" + keys[k] + " - " + miscdedObj[keys[k]];;
        }

      }
      if (str2 != "") {
        arr.push({ text: str2, fontSize: 8 });
      }
      else {
        arr.push(0.00);
      }

      arr.push({ text: obj['net'], bold: true });

      dd.content[dd.content.length - 1].table.body.push(arr);

    }
    var sectionText = { text: 'Grand Total' + "\nTotal Employees : " + count, fontSize: 10, bold: true };

    var obj = grand;
    var arr = []
    arr.push(sectionText);
    arr.push(obj['BASIC']);
    arr.push(obj['DEP']);
    arr.push(obj['DA']);
    arr.push(obj['MA']);
    arr.push(obj['VA']);
    arr.push(obj['HRA']);
    arr.push(obj['WA']);
    var miscpay = obj['miscpay'];
    var miscpayObj: any = {};
    for (var k = 0; k < miscpay.length; k++) {
      if (miscpayObj[miscpay[k]['code']] == undefined) {
        miscpayObj[miscpay[k]['code']] = 0;
      }
      miscpayObj[miscpay[k]['code']] += miscpay[k]['amount'];
    }
    var str2 = "";
    var keys = Object.keys(miscpayObj);
    for (var k = 0; k < keys.length; k++) {
      if (k == 0) {
        str2 += keys[k] + " - " + miscpayObj[keys[k]];
      } else {
        str2 += "\n" + keys[k] + " - " + miscpayObj[keys[k]];;
      }

    }
    if (str2 != "") {
      arr.push({ text: str2, fontSize: 8 });
    }
    else {
      arr.push(0.00);
    }
    arr.push({ text: obj['total'], bold: true });
    var amt = obj['LIC1'] + obj['LIC2'] + obj['LIC3'] + obj['LIC4'] + obj['LIC5'] + obj['LIC6'] + obj['LIC7']
    //var licstr=obj['LIC1']+"\n"+obj['LIC2']+"\n"+obj['LIC3']+"\n"+obj['LIC4']+"\n"+obj['LIC5']+"\n"+obj['LIC6']+"\n"+obj['LIC7'];
    //var licstr={ text: 'Section : '+sections[i]+"\nTotal Employees : "+emps.length, fontSize: 8};
    arr.push(amt);
    arr.push(obj['PF']);
    arr.push(obj['NPS']);
    arr.push(obj['GIS']);
    arr.push(obj['IT']);
    arr.push(obj['HRR']);
    arr.push(obj['VD']);
    arr.push(obj['VADV']);
    amt = obj['BLDADV1'] + obj['BLDADV2'] + obj['BLDADV3'];
    //var bldstr=obj['BLDADV1']+"\n"+obj['BLDADV2']+"\n"+obj['BLDADV3']
    arr.push(amt);
    amt = obj['PFADV'] + obj['PFADV1'] + obj['PFADV2'];
    //var pfstr=obj['PFADV']+"\n"+obj['PFADV1']+"\n"+obj['PFADV2']
    arr.push(amt);
    arr.push(obj['BADV']);
    arr.push(obj['EWF']);
    var miscded: any = obj['miscded'];
    var miscdedObj: any = {};
    for (var k = 0; k < miscded.length; k++) {
      if (miscdedObj[miscded[k]['code']] == undefined) {
        miscdedObj[miscded[k]['code']] = 0;
      }
      miscdedObj[miscded[k]['code']] += miscded[k]['amount'];
    }
    var str2 = "";
    var keys = Object.keys(miscdedObj);
    for (var k = 0; k < keys.length; k++) {
      if (k == 0) {
        str2 += keys[k] + " - " + miscdedObj[keys[k]];
      } else {
        str2 += "\n" + keys[k] + " - " + miscdedObj[keys[k]];;
      }

    }
    if (str2 != "") {
      arr.push({ text: str2, fontSize: 8 });
    }
    else {
      arr.push(0.00);
    }

    arr.push({ text: obj['net'], bold: true });

    dd.content[dd.content.length - 1].table.body.push(arr);
    dd.content.push("\n\n");
    var sign = {
      columns: [
        {
          // auto-sized columns have their widths based on their content
          width: 'auto',
          text: 'PREPARED BY:',
          bold: true,
          fontSize: 10
        },
        {
          // auto-sized columns have their widths based on their content
          width: 'auto',
          text: 'CHECKED BY:',
          bold: true,
          fontSize: 10
        },
        {
          // auto-sized columns have their widths based on their content
          width: 'auto',
          text: 'SIGNED BY:',
          bold: true,
          fontSize: 10
        },


      ]
    }
    dd.content.push("\n\n\n");
    dd.content.push("PREPARED BY:                               CHECKED BY:                           SIGNED BY:                         ");
    dd.content.push("\n\n");
    dd.content.push("CERTIFIED:")
    dd.content.push("\n\n");
    dd.content.push({ text: "1. That I have satisfied myself that all the salaries included in the bills drawn in the month of " + this.monthObj[month] + "/" + fin_year + " [the last preceding month] with the exception of those detailed below of which total has been refunded by deduction from the bill has been distributed to the proper persons and their receipts have been taken in acquittance rolls field in my office with reciept-stamp dully cancelled for every payment in access of Rs. 20 and that all leaves and promotions etc have been in the service book of the official concerned." })
    dd.content.push("\n");
    dd.content.push({ text: "2. That all persons for whom pay has been drawn in this bill have actually been entertained during the month." })
    dd.content.push("\n");

    dd.content.push({ text: "3. That all the persons for whom house-rent allowance has been shown in this bill actually occupied a rented house for which they paid rent as shown in this bill and are entitled to the allowance under the standing instructions." })
    dd.content.push("\n");

    dd.content.push({ text: "4. That all the persons in respect of whom conveyance allowance has been drawn in the bill have satisfied me that they have actually maintained the conveyance in a workable condition and have been using them." })
    dd.content.push("\n");

    dd.content.push({ text: "5. That the bill has been checked with the sanctioned in the scale register." })
    dd.content.push("\n");

    dd.content.push({ text: "Date :                                                    Signature Of Drawing Officer:" })
    dd.content.push("\n");

    dd.content.push({ text: "Pay Rs. ....................................." })


    pdfMake.createPdf(dd).download();
  }

  // async certificate() {
  //   var account_name = this.erpUser["account_name"];
  //   var account_short_name = this.erpUser["account_short_name"];
  //   var txt = account_name + "(" + account_short_name + ") \n";

  //   if (this.PrintObj['doc_type'] == "SAL_BILL" || this.PrintObj['doc_type'] == "AA_BILL") {
  //     let dd: any = {
  //       pageSize: "A3",
  //       header: function (currentPage: any, pageCount: any) {
  //         let arr = [];
  //         let obj = {
  //           text: txt,
  //           alignment: "center",
  //           margin: [72, 40],
  //           fontSize: 15,
  //           bold: true,
  //         };
  //         arr.push(obj);
  //         return arr;
  //       },
  //       pageOrientation: "portrait",
  //       pageMargins: [40, 60, 40, 60],
  //       content: [],
  //     };

  //     let header1 = {
  //       columns: [
  //         {
  //           width: "*",
  //           text: 'APPROVAL LOG  - ' + '  ' + (this.PrintObj && this.PrintObj["doc_desc"] ? this.PrintObj["doc_desc"] : 0),
  //           bold: true,
  //           alignment: "center",
  //         },
  //       ],
  //     };
  //     dd.content.push({ text: " " });
  //     dd.content.push(header1);
  //     dd.content.push({ text: " " });
  //     var tbl1 = {
  //       fontSize: 15,
  //       table: {
  //         headerRows: 1,
  //         widths: [70, 124, 124, 124, 144, 125],
  //         body: [
  //           ["User ID", "User Name", "Designation", "Action", "Date", "Remark"],
  //         ],
  //       },
  //     };
  //     for (var i = 0; i < this.statusArr.length; i++) {
  //       var arr = [];
  //       arr.push(this.statusArr[i]["user_id"]);
  //       arr.push(this.statusArr[i]["name"]);
  //       if (this.statusArr[i]["role_cd"] != "Contractor") {
  //         arr.push(this.statusArr[i]["role_cd"]);
  //       } else {
  //         arr.push(this.statusArr[i]["role_cd"]);
  //       }
  //       arr.push(this.statusArr[i]["status"]);
  //       arr.push(this.statusArr[i]["create_timestamp"])
  //       arr.push(this.statusArr[i]["remark"]);
  //       tbl1.table.body.push(arr);
  //     }
  //     dd.content.push(tbl1);
  //     pdfMake.createPdf(dd).download("running-bill-cert" + ".pdf");


  //   }
  //   else if (this.PrintObj['module_cd'] === 'ACCOUNT') {
  //     await this.processDocumentPrintService.printCertificate(this.PrintObj, this.statusArr)
  //   }
  //   else {

  //     //var txt = "LUCKNOW DEVELOPMENT AUTHORITY" + "(" + "LDA" + ") , LUCKNOW\n" + "VIPIN KHAND,GOMTI NAGAR , LUCKNOW - 226010";
  //     var dd: any = {
  //       pageSize: "A3",
  //       header: function (currentPage: any, pageCount: any) {
  //         var arr = [];
  //         var obj = {
  //           text: txt,
  //           alignment: "center",
  //           margin: [72, 40],
  //           fontSize: 15,
  //           bold: true,
  //         };
  //         arr.push(obj);
  //         return arr;
  //       },
  //       pageOrientation: "portrait",
  //       pageMargins: [40, 60, 40, 60],
  //       content: [],
  //     };
  //     var header1 = {
  //       columns: [
  //         {
  //           width: "*",
  //           text:
  //             "APPROVAL LOG  FOR FILE/EMB NO - " +
  //             this.selectedTender["already_emb"],
  //           bold: true,
  //           alignment: "center",
  //         },
  //       ],
  //     };
  //     dd.content.push({ text: " " });
  //     dd.content.push(header1);
  //     dd.content.push({ text: " " });
  //     var tbl: any = {
  //       fontSize: 10,
  //       table: {
  //         headerRows: 0,
  //         widths: [370, 375],
  //         body: [],
  //       },
  //     };
  //     var workObj = this.workObj[this.selectedTender["work_id"]];
  //     var partyObj = this.partyObj[this.selectedTender["party_id"]];
  //     var arr = [];
  //     arr.push({ text: "Name Of Contractor ", bold: true });
  //     arr.push(partyObj);
  //     tbl.table.body.push(arr);
  //     arr = [];
  //     arr.push({ text: "Name Of Work ", bold: true });
  //     arr.push(workObj["work_order_name"]);
  //     tbl.table.body.push(arr);
  //     arr = [];
  //     arr.push({ text: "Estimate No ", bold: true });
  //     arr.push("");
  //     tbl.table.body.push(arr);
  //     arr = [];
  //     arr.push({ text: "Work Order No ", bold: true });
  //     arr.push(workObj["work_order_no"]);
  //     tbl.table.body.push(arr);
  //     arr = [];
  //     arr.push({ text: "Agreement Dated ", bold: true });
  //     arr.push(workObj["agr_dt"]);
  //     tbl.table.body.push(arr);
  //     dd.content.push(tbl);
  //     dd.content.push({ text: " " });
  //     dd.content.push({ text: " " });
  //     var tbl1 = {
  //       fontSize: 15,
  //       table: {
  //         headerRows: 1,
  //         widths: [70, 124, 124, 124, 144, 125],
  //         body: [
  //           ["User ID", "User Name", "Designation", "Action", "Date", "Remark"],
  //         ],
  //       },
  //     };
  //     for (var i = 0; i < this.statusArr.length; i++) {
  //       var arr = [];
  //       arr.push(this.statusArr[i]["user_id"]);
  //       arr.push(this.statusArr[i]["user_name"]);
  //       if (this.statusArr[i]["role_cd"] != "Contractor") {
  //         arr.push(this.embMainService.roleCodeToRoleDescription[this.statusArr[i]["role_cd"]]);
  //       } else {
  //         arr.push(this.statusArr[i]["role_cd"]);
  //       }
  //       arr.push(this.statusArr[i]["status"]);
  //       arr.push(this.statusArr[i]["timestamp"]);
  //       arr.push(this.statusArr[i]["remark"]);
  //       tbl1.table.body.push(arr);
  //     }
  //     dd.content.push(tbl1);
  //     pdfMake.createPdf(dd).download("running-bill-cert" + ".pdf");
  //   }




  // }

  // /////insert in jrnl after getting DOC type BP of Approved Status A.......P /////////////////
  all_party: any = []
  AllPartyObj: any = {};
  fin_year: any
  allChartOfAccountObj: any = {};
  allChartOfAccount: any = [];
  async getallChartOfAccount() {
    this.spinner.show()
    var obj: any = new Object();
    obj['b_acct_id'] = this.b_acct_id;
    var resp = await this.ruleService.getchartofaccount(JSON.stringify(obj));
    if (resp['error'] == false) {
      this.allChartOfAccount = resp.data;
      this.allChartOfAccountObj = {};
      this.allChartOfAccount.map((x: any) => {
        this.allChartOfAccountObj[x['leaf_code']] = x['leaf_value']
      })

      this.spinner.hide();
    } else {
      this.spinner.hide()
      this.snackBar.open("Error while getting  all chart of account info", 'Error', {
        duration: 5000
      });
    }
  }
  async getActiveFinYear() {
    var obj: any = new Object();
    obj['b_acct_id'] = this.b_acct_id;
    var resp = await this.ledgerService.getActiveFinYear(JSON.stringify(obj));
    if (resp['error'] == false) {
      if (resp.data.length == 0) {
        swal.fire("Warning", "..Active Financial Year Not set!", 'warning');
      } else {
        this.fin_year = resp.data[0].fin_year;
      }
    } else {
      swal.fire("Error", "..Error while getting active  fin year!", 'error');
    }
  }
  async getAllParties() {
    var resp = await this.settingService.getAllpartiesNew(this.b_acct_id);
    if (resp['error'] == false) {
      this.all_party = [{ le_id: 0, emp_name: 'All' }];
      resp['data'].map((x: any) => {
        this.all_party.push(x);
        this.AllPartyObj[x['le_id']] = x['emp_name']
      });

    }
  }


  async getVendors() {
    var resp = await this.settingService.getAllVendors();
    if (resp['error'] == false) {
      resp['data'].map((x: any) => {
        this.AllPartyObj[x['le_id']] = x['org_name']
      });
    }
  }



  async updateBpStatusInJrnl(bp_ids: any) {
    let obj: any = new Object();
    obj['b_acct_id'] = this.b_acct_id;
    obj['bp_ids'] = bp_ids;
    obj['status'] = 'POSTED';
    obj['update_user_id'] = this.erpUser.le_id;
    let resp = await this.BPS.updateBpStatusInJrnl(obj);
    if (resp['error'] == false) {
      swal.fire('SUCCESS', 'Succesfully posted bank payment', 'success');
    } else {

      swal.fire("ERROR", "Error while posting bank payment", 'error');
      return;
    }
  }


  // async insert_jrnl(arr) {
  //   let obj:any = {};
  //   obj['b_acct_id'] = this.erpUser.b_acct_id
  //   obj['bp_id'] = arr
  //   let resp = await this.BPS.getList(JSON.stringify(obj));
  //   if (resp['error'] == false) {
  //     let bank_paymnet_data: any = []
  //     bank_paymnet_data = resp['data']
  //     var arr1 = []
  //     bank_paymnet_data.map(async (x, i) => {
  //       var event = JSON.parse(x['data'])
  //       let ob_db = new Object();
  //       ob_db = {
  //         "arr_id": event['arr_id'],
  //         "acct_dt": this.systemDate,
  //         "appr_id": this.erpUser.user_id,
  //         "ar_src_cd": "ACCOUNT",
  //         "ar_num_in_src": null,
  //         "ar_actvty_tcd": "BP",
  //         "ar_actvty_lcl_num": x['id'],
  //         "ar_instr_cd": event['ar_instr_cd'],
  //         "ar_cntr_ip_id": event['party_id'],
  //         "ar_cntr_ip_name": event['party_leagal_name'],
  //         "create_timestamp": this.systemDate,
  //         "chart_of_account": event['chart_of_account'],
  //         "cp_bnk_acct_id": 0,
  //         "db_cd_ind": "DB",
  //         "event_code": event['event_code'],
  //         "event_id": event['event_id'],
  //         "ev_cts": event['bp_date'],
  //         "fin_year": this.fin_year,
  //         "jrnl_dtl_ln_id": "1",
  //         "jrnl_ln_id": 1,
  //         "jrnl_id": event['jrnl_id'],
  //         "jrnl_desc": 'To ' + this.allChartOfAccountObj[event['bank_chart_of_account']],
  //         "ledger_type": "ACT",
  //         "ld_jrnl_ref_num": event['ld_jrnl_ref_num'],
  //         "ld_jrnl_lfcycl_st_cd": "POSTED",
  //         "ld_jrnl_unpost_seq_num": 0,
  //         "ld_fm": 11,
  //         "ld_acct_per": 328,
  //         "ld_cat_cd": "FIN",
  //         "ld_jrnl_entry_cd": "Auto",
  //         "ld_tgt_cur_tcd": "FN",
  //         "ld_jrnl_rvrsl_tcd": event['ld_jrnl_rvrsl_tcd'],
  //         "ld_jrnl_rvrsl_dt": null,
  //         "ld_parent_jrnl_id": null,
  //         "ld_jrnl_ln_ksn": event['jrnl_id'] + "-DB",
  //         "ld_jrnl_ln_desc": event['jrnl_desc'],
  //         "ld_bk_cd": null,
  //         "ld_src_cd": "ACCOUNT",
  //         "ld_pd_cd": event['ld_pd_cd'],
  //         "ld_prj_cd": event['ld_prj_cd'],
  //         "ld_jrnl_dtl_ln_ksn": "_" + 1 + "_0",
  //         "ld_tech_comp_cd": "ARE",
  //         "ld_jrnl_dtln_desc": event['jrnl_desc'],
  //         "ld_bus_func_cd": "JV2BP",
  //         "ld_unadj_acct_dt": this.systemDate,
  //         "org_unit_cd": this.b_acct_id,
  //         "proc_dt": null,
  //         "prep_id": this.erpUser.user_id,
  //         "pmt_bnk_acct_id": 0,
  //         "tgt_curr_cd": "INR",
  //         "txn_amt": (-1) * event['txn_amt'],
  //         "ld_cc_cd": event['ld_cc_cd'],
  //         "ld_aff_cc_cd": "0",
  //         "ld_bugt_cd": event['ld_bugt_cd']
  //       }

  //       let ob_cr = new Object();
  //       ob_cr = {
  //         "arr_id": event['arr_id'],
  //         "acct_dt": this.systemDate,
  //         "appr_id": this.erpUser.user_id,
  //         "ar_src_cd": "ACCOUNT",
  //         "ar_num_in_src": null,
  //         "ar_actvty_tcd": "BP",
  //         "ar_actvty_lcl_num": x['id'],
  //         "ar_instr_cd": event['ar_instr_cd'],
  //         "ar_cntr_ip_id": event['party_id'],
  //         "ar_cntr_ip_name": this.AllPartyObj[event['party_id']],
  //         "create_timestamp": this.systemDate,
  //         "chart_of_account": event['bank_chart_of_account'],
  //         // "cp_bnk_acct_id": event['org_bank_acct_no'],
  //         "cp_bnk_acct_id": event['relation'],
  //         "db_cd_ind": "CR",
  //         "event_code": event['event_code'],
  //         "event_id": event['event_id'],
  //         "ev_cts": event['bp_date'],
  //         "fin_year": this.fin_year,
  //         "jrnl_dtl_ln_id": "1",
  //         "jrnl_ln_id": 1,
  //         "jrnl_id": event['jrnl_id'],
  //         "jrnl_desc": 'By ' + this.allChartOfAccountObj[event['bank_chart_of_account']],
  //         "ledger_type": "ACT",
  //         "ld_jrnl_ref_num": event['ld_jrnl_ref_num'],
  //         "ld_jrnl_lfcycl_st_cd": "POSTED",
  //         "ld_jrnl_unpost_seq_num": 0,
  //         "ld_fm": 11,
  //         "ld_acct_per": 328,
  //         "ld_cat_cd": "FIN",
  //         "ld_jrnl_entry_cd": "Auto",
  //         "ld_tgt_cur_tcd": "FN",
  //         "ld_jrnl_rvrsl_tcd": event['ld_jrnl_rvrsl_tcd'],
  //         "ld_jrnl_rvrsl_dt": null,
  //         "ld_parent_jrnl_id": null,
  //         "ld_jrnl_ln_ksn": event['jrnl_id'] + "-CR",
  //         "ld_jrnl_ln_desc": event['jrnl_desc'],
  //         "ld_bk_cd": null,
  //         "ld_src_cd": "ACCOUNT",
  //         "ld_pd_cd": event['ld_pd_cd'],
  //         "ld_prj_cd": event['ld_prj_cd'],
  //         "ld_jrnl_dtl_ln_ksn": "_" + 1 + "_0",
  //         "ld_tech_comp_cd": "ARE",
  //         "ld_jrnl_dtln_desc": event['jrnl_desc'],
  //         "ld_bus_func_cd": "JV2BP",
  //         "ld_unadj_acct_dt": this.systemDate,
  //         "org_unit_cd": this.b_acct_id,
  //         "proc_dt": null,
  //         "prep_id": this.erpUser.user_id,
  //         "pmt_bnk_acct_id": 0,
  //         "tgt_curr_cd": "INR",
  //         "txn_amt": event['txn_amt'],
  //         "ld_cc_cd": event['ld_cc_cd'],
  //         "ld_aff_cc_cd": "0",
  //         "ld_bugt_cd": event['ld_bugt_cd']
  //       }


  //       await arr1.push(ob_cr, ob_db)
  //       // await arr1.push(ob_db)
  //       //  jrnl_data[x.id] = arr1
  //     })

  //     var obj1 = {}
  //     obj1['b_acct_id'] = this.b_acct_id;
  //     obj1['jrnl'] = arr1;
  //     var resp2 = await this.BPS.insertProcessedbp(obj1);
  //     if (resp2['error'] == false) {
  //       this.spinner.hide();
  //       swal.fire("Success", "Processed Successfully!", 'success');

  //     } else {
  //       this.spinner.hide();
  //       swal.fire("Error", "...Error while Processed  !", 'error');

  //     }




  //   } else {
  //     swal.fire('errror', 'server side error', 'error');
  //     return
  //   }
  // }
  // vendor_bill(element: any) {
  //   this.vbillservice.billview = { 'element': element, flag: true }
  //   this.router.navigate(['/operation/bill'])
  // }

  /*------------------S bill print -----------------------*/
  // async printBill(bill_id: any) {
  //   await this.billPrintService.print1(bill_id, 'OPEN_ON_WINDOW')
  // }

  /*------------------bill print E-----------------------*/

  imgURL1: any;
  // async viewInvoice(element: any, doc: any) {
  //   let obj: any = {}
  //   obj['b_acct_id'] = this.b_acct_id

  //   // obj['vendor_id'] = this.selectBill['vendor_id']
  //   // if(element[doc]){
  //   //   Swal.fire('Opps!!',`In this bill document is not uploaded`,'error')
  //   //   return;
  //   // }
  //   obj['file_name'] = doc
  //   obj['bill_id'] = element['doc_local_no']
  //   obj['doc_type'] = doc
  //   this.spinner.show()
  //   let res = await this.vbillservice.getbill_document(obj)
  //   try {

  //     if (res) {
  //       let file = new Blob([res], { type: "application/pdf" });
  //       var fileURL = URL.createObjectURL(file);
  //       window.open(fileURL);
  //       this.spinner.hide();
  //     } else {
  //       this.spinner.hide();
  //     }
  //   } catch (error) {
  //     this.spinner.hide();
  //     swal.fire('Error', `Can't fetch at the moment. Please try again later`, 'error')
  //   }

  // }


  async viewJCR_InvoiceDocument(element: any, view_doc_type: any) {
    await this.processDocumentPrintService.viewJCR_Invoice({ ...element, is_account_module: 0 }, view_doc_type)
  }
  async viewCBInvoiceDoc(element: any, type: any) {
    let ind = type === 'CB' ? 1 : 0
    await this.billService.viewDocument({ cb_id: element.doc_local_no, is_cb_comp: ind, b_acct_id: this.b_acct_id })
  }


  // async getSubsidyDocument(element: any) {
  //   let obj: any = {}
  //   obj["b_acct_id"] = this.b_acct_id;
  //   obj["id"] = element.doc_local_no;
  //   obj['doc_type'] = 'SUBSIDY_BILL'
  //   this.spinner.show();
  //   const resp = await this.eventGroupService.getBillIdAndWorkOrderIdOnEventId(JSON.stringify(obj));
  //   if (resp['error'] == false) {
  //     await this.subsidyService.excelExport(JSON.stringify({ id: element['local_doc_no'], b_acct_id: this.b_acct_id }))
  //     this.spinner.hide()
  //   } else {
  //     this.spinner.hide();
  //     swal.fire("Error", "Error while getting Subsidy Bill");
  //   }
  // }

  /*---------------------view work order s--------------------------*/

  //   async viewWorkOrder(element: any) {
  //     let obj: any = {}
  //     obj["b_acct_id"] = this.b_acct_id;
  //     obj["id"] = element.doc_local_no;
  //     // obj['doc_type'] = obj2.doc_type
  //     obj['module_doc_type'] = 'VENDOR_BILL_OPERATION'
  //     obj['doc_type'] = 'VENDOR_BILL_OPERATION'
  //     this.spinner.show();
  //     var resp = await this.eventGroupService.getBillIdUsingEventId(JSON.stringify(obj));
  //     if (resp['error'] == false) {
  //       this.spinner.hide()
  //       await this.workOrder({ doc_local_no: resp['data'][0]['work_order_id'], doc_type: element.doc_type })
  //  // await this.workOrder({ doc_local_no: resp['data'][0]['work_order_id'], doc_type: element.doc_type ,work_order_id: resp['data'][0]['work_order_id']})
  // //  await this.workOrder({ doc_local_no: resp['data'][0]['local_doc_no'], doc_type: element.doc_type ,work_order_id: resp['data'][0]['local_doc_no']})


  //       return { error: false }
  //     } else {
  //       this.spinner.hide();
  //       swal.fire("Error", "Error while getting status");
  //       return { error: true }
  //     }
  //   }


  // async viewWorkOrder(element: any) {
  //   let obj: any = {}
  //   obj["b_acct_id"] = this.b_acct_id;
  //   obj["id"] = element.doc_local_no;
  //   // obj['doc_type'] = obj2.doc_type
  //   obj['module_doc_type'] = 'VENDOR_BILL_OPERATION'
  //   obj['doc_type'] = 'VENDOR_BILL_OPERATION'
  //   this.spinner.show();
  //   var resp = await this.eventGroupService.getBillIdUsingEventId(JSON.stringify(obj));
  //   if (resp['error'] == false) {
  //     this.spinner.hide()
  //     await this.workOrder({ doc_local_no: resp['data'][0]['local_doc_no'], doc_type: element.doc_type })
  //     return { error: false }
  //   } else {
  //     this.spinner.hide();
  //     swal.fire("Error", "Error while getting status");
  //     return { error: true }
  //   }
  // }
  // work_order_data: any = []
  // workOrderObj: any = {}
  // costCenter_obj: any = {}
  // async workOrder(element: any) {
  //   let obj: any = {}
  //   obj['b_acct_id'] = this.b_acct_id
  //   obj['work_order_id'] = element.doc_local_no
  //   obj['doc_type'] = element.doc_type
  //   let resp = await this.wos.getpreviewwo(obj)
  //   if (resp['error'] == false) {
  //     obj['module_cd'] = 'OPERATION'
  //     let re = await this.operationMainService.getCostCenter(obj)
  //     this.workOrderObj = resp['data'][0]
  //     if (resp['data'][0] && this.workOrderObj['copy_to']) {
  //       this.workOrderObj['copy_to'] = JSON.parse(this.workOrderObj['copy_to'])
  //     }
  //     this.work_order_data = resp['item_data']
  //     re['data'].map((x: any) => {
  //       this.costCenter_obj[x['cc_code']] = x
  //     })

  //     $('#workOrder').show()
  //   } else {
  //     swal.fire('Error', resp['data'], 'error')
  //   }
  // }
  async closemodal() {
    $('#workOrder').hide()
  }
  async clickDifferenceMode() {
    $('#viewdiffrence_data').hide()
  }



  async open_update_cb(element: any) {
    this.billService.open_update_from_task = true;
    this.billService.cb_id = element.doc_local_no;
    this._router.navigate(['/accounts/bill']);

  }

  /*---------------------view work order e--------------------------*/
  async Changestatusreapointbill(bill_id: any, bill_status_code: any) {
    var obj: any = new Object();
    obj['b_acct_id'] = this.b_acct_id;
    obj['update_user_id'] = this.erpUser.user_id;
    obj['id'] = bill_id;
    obj['status'] = bill_status_code;
    // obj['bill_status_code'] = "UNDERAPPROVAL";
    // obj['bill_status_code'] = "APPROVED";
    this.spinner.show();
    var resp = await this.payableService.changereapointmentsatus(obj);
    if (resp['error'] == false) {
      //await this.sendToApproval(resp['data']);
      // setTimeout(async () => {
      //   // await this.getAllSuspended();
      //   //await this.insertIntoAccount(1);
      //   this.spinner.hide();
      //   Swal.fire('Success', 'Bill Approved Successfully');
      // }, 1000);
      // await this.editorService.clearTetx()
      // this.isApprovalActive = false
    } else {
      this.spinner.hide();
      Swal.fire('Error', 'Error in Bill Generation', 'error');
    }

  }








  // death//////////////////////////////////////////




  async Changedeathstatus(bill_id: any, bill_status_code: any) {
    var obj: any = new Object();
    obj['b_acct_id'] = this.b_acct_id;
    obj['update_user_id'] = this.erpUser.user_id;
    obj['max_susp_id'] = bill_id;
    obj['status'] = bill_status_code;
    // obj['bill_status_code'] = "UNDERAPPROVAL";
    // obj['bill_status_code'] = "APPROVED";

    obj['employee_current_type_code'] = 'DEATH'
    obj["check"] = 'task'
    this.spinner.show();
    var resp = await this.payableService.Changedeathstatus(obj);
    if (resp['error'] == false) {
      //await this.sendToApproval(resp['data']);

      // await this.editorService.clearTetx()
    } else {
      this.spinner.hide();
      swal.fire('Error', 'Error in Bill Generation', 'error');
    }

  }



  async viewWorkDoc(element: any, key: any) {
    let obj_doc = Object()
    obj_doc['b_acct_id'] = this.b_acct_id;
    obj_doc['work_id'] = element.doc_local_no;
    obj_doc['key'] = key

    // if (element.doc_type === 'FILE') {
      await this.workS.viewWorkDocOnId(obj_doc)
    // } else if (element.doc_type === 'COMPUTER_FILE') {
    //   await this.ComputerFileService.viewWorkDocOnId(obj_doc)
    // } else if (element.doc_type === 'STM_FILE') {
    //   await this.stmFileService.viewWorkDocOnId(obj_doc)
    // }
  }


  // async viewWorkDocByName(element: any, file_name: any) {
  //   let obj_doc = Object()
  //   obj_doc['b_acct_id'] = this.b_acct_id;
  //   obj_doc['work_id'] = element.work_id;
  //   obj_doc['file_name'] = file_name

  //   if (this.currentObject.doc_type === 'FILE') {
  //     await this.workS.viewDoc(obj_doc)
  //   } else if (this.currentObject.doc_type === 'COMPUTER_FILE') {
  //     await this.ComputerFileService.viewDoc(obj_doc)
  //   } else if (this.currentObject.doc_type === 'STM_FILE') {
  //     await this.stmFileService.viewDoc(obj_doc)
  //   }
  // }

  async viewMedicalDocument(element: any) {
    await this.processDocumentPrintService.printMedicalDoc({ bill_id: element.doc_local_no, is_account_module: 0 })
  }



}
